import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
  await1kke5zj2piplv as await_0,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import {
  PendingItemChange1hwhwykx2kyit as PendingItemChange,
  PendingLineItem7uj25viy3ie8 as PendingLineItem,
  Specification3fgfbf7ihgj8v as Specification,
  ChangeRequesthd3ysa2j1i4f as ChangeRequest,
  LineItem2rt64afaiyloc as LineItem,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_itemNumber3opyx7hv723x5 as get_itemNumber,
  get_priceChangeq2x4gvw2nnoa as get_priceChange,
  get_updatedDescription163szj45iknds as get_updatedDescription,
  get_created19174y6ey1rv2 as get_created,
  get_changeRequestajwchxq3dicy as get_changeRequest,
} from '../../../../../../../../crowpay-shared/com/crowpay/PendingItemChangeFields.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  set_value1vvx5pkb20ebv as set_value,
  modify2eca96i8s7hc2 as modify,
  withWritedlio9p0oewet as withWrite,
  interceptWrite2xi6g5kl52xuu as interceptWrite,
} from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem_0,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  weightt34o7llf2uyq as weight,
  shownWhenxgf1ujy6rmvr as shownWhen,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  forEach37zw770vd3h4l as forEach,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  expandIcon1as9er6lyg7in as expandIcon,
  expandAction2iatt63opw8h9 as expandAction,
  leftExpandButton23soimuuf6gel as leftExpandButton,
} from '../../../expansion.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  smallBody2trfy14zwtona as smallBody,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  body3i5t0n7zprpqb as body,
  title1ahgushtajx2d as title,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
} from '../../../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../../../theming/colorManagement.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__unaryMinus_impl_x5smq036mvwk2sni6rt as MonetaryValue__unaryMinus_impl_x5smq0,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { renderPriceChangegxsbuhvani39 as renderPriceChange } from '../../../priceChanges.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  InvalidSemantic_getInstance19jq406epp0mv as InvalidSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  DisabledSemantic_getInstanceimdypc22j9b3 as DisabledSemantic_getInstance,
  ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  assertReactive30c64mz7ckt8m as assertReactive,
  assertNotBlank3rcqh0n27fq5q as assertNotBlank,
} from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import {
  dynamicThemexp3sdnaolntz as dynamicTheme,
  get_compact3lsezez8nz8b6 as get_compact,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_1 } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { MonetaryValueInput2lk8s753hzo22 as MonetaryValueInput } from '../../../MonetaryValueInput.mjs';
import {
  zeroToNull11q39tqjxlqyg as zeroToNull,
  resize3py5p2yrjp6p7 as resize,
  goBackOrReplaceWith1hxiq2flhlluq as goBackOrReplaceWith,
  share11y1uwr9hp0zm as share,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  Action1a4ymn5nx79hk as Action,
} from '../../../../../utils/utils.mjs';
import {
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../../nav/crowpay.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import {
  nullToBlank2cwx9yazfqg5v as nullToBlank,
  equalTo2dio0vrcsd3je as equalTo,
} from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import {
  errorTextv58wi1t0me7u as errorText,
  icon1sxjaie5w1apt as icon,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  DangerButtonSemantic_getInstanceb7gofax87736 as DangerButtonSemantic_getInstance,
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredContent3evlhhbrk2e00 as specCenteredContent,
  PrimaryButtonSemantic_getInstance2oopjxbt9oc9b as PrimaryButtonSemantic_getInstance,
  specCenteredText33v0vmsdeuehr as specCenteredText_0,
} from '../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  get_trash3qsdn4kaynjmu as get_trash,
  get_linked25zbblktmzgbh as get_linked,
  get_edit2tiiawv2658bs as get_edit,
} from '../../../../../icons.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_issues1z1skb5sgeygq as get_issues,
  MutableValidated2ognu5vxf17ur as MutableValidated,
} from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  pushChanges1lnw8bjwewvzf as pushChanges,
  updatePublished2dsy69cya4hmm as updatePublished,
} from '../../../../../utils/Draft.ext.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog,
  confirmationDialog1lynowl7yd4cd as confirmationDialog,
} from '../../../../dialogs/GenericConfirmationDialog.mjs';
import {
  get_itemNumber2q6tr7iizmkdb as get_itemNumber_0,
  get_created3km9fnevcxvgw as get_created_0,
  get_changeRequest1kn1g9zivscde as get_changeRequest_0,
  get_linkedwb9jodr9vc0 as get_linked_0,
} from '../../../../../../../../crowpay-shared/com/crowpay/PendingLineItemFields.mjs';
import { get_notNullContractorsjk9enub7uol as get_notNullContractor } from '../../../../../selectedContractor.mjs';
import { resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments } from '../../../files/attachmentFilePreview.mjs';
import { confirmNewSpecDialog2atpg2wu5rk54 as confirmNewSpecDialog } from '../../../../dialogs/ConfirmNewSpecDialog.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  asyncz02dsa2nb2zt as async,
  launch1c91vkjzdi9sd as launch,
} from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { awaitAll3u8r91uegk3sa as awaitAll } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope284yy3flyb2v2 as coroutineScope,
} from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance,
  get_entries3ali93lr48zte as get_entries,
  LineItemState_InProgress_getInstance30c0b4tuqukui as LineItemState_InProgress_getInstance,
  ChangeType_Modify_getInstance2320ide7eqjcd as ChangeType_Modify_getInstance,
  ChangeType_Remove_getInstance2qh3m0yr0lh4w as ChangeType_Remove_getInstance,
  ChangeType_New_getInstance3fouji82nef8w as ChangeType_New_getInstance,
} from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { verifyContractor3ixd4tkg6xaiu as verifyContractor } from '../../../../screens/contractor/IsContractorScreen.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator,
  get_pageNavigator1inl9j7ja0vlf as get_pageNavigator,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { LandingScreennv9edtrim3be as LandingScreen } from '../../../../screens/common/LandingScreen.mjs';
import {
  withIndex37cl61h9v5txo as withIndex,
  toSet2orjxp16sotqu as toSet,
  joinToString1cxrrlmo0chqs as joinToString,
  plus310ted5e4i90h as plus,
  sortedWith2csnbbb21k0lg as sortedWith,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ContractorProject2o386x7rid4t as ContractorProject } from '../../../../screens/contractor/ContractorProject.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import {
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  listOfvhqybd2zx248 as listOf,
  setOf1u3mizs95ngxo as setOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { newChangesAlloweduwl70y4cy8dt as newChangesAllowed } from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { renderToString1atd3jbop96tk as renderToString } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import {
  get_title1uuo24n337kui as get_title,
  get_descriptionchu6hh0rofv7 as get_description,
  get_scopeSet2gpz9zq10ib51 as get_scopeSet,
  get_linkItems1axtwhl2yveby as get_linkItems,
  get_cardinalChangeebt4rzfla0rg as get_cardinalChange,
} from '../../../../../../../../crowpay-shared/com/crowpay/ChangeRequestFields.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../theming/separators.mjs';
import {
  space2ppi73m2qk1br as space,
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
} from '../../../space.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { InnerTabBar_getInstance20l55y0u7bopn as InnerTabBar_getInstance } from '../../../../theming/tabs.mjs';
import { RadioToggleButton6jdt9lqh3p8p as RadioToggleButton } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioToggleButton.commonHtml.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { TargetHandler3hwg57jh7lzun as TargetHandler } from '../../../../../utils/JumpTo.mjs';
import {
  Draft43syxm8fng0j as Draft,
  Draftj5auffrm1u2b as Draft_0,
} from '../../../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../../../sdk/errors.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  mutableRemember1h6fyyolumj0o as mutableRemember,
  MutableRememberyv35kz5kmml7 as MutableRemember,
} from '../../../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { TargetHandler15cm4auxqf0yk as TargetHandler_0 } from '../../../../../utils/RequestFocus.mjs';
import {
  get_section1qyzr1npzel2z as get_section,
  get_lightSection4cpu8okr0w14 as get_lightSection,
  get_darkSection25mxxvxk8ts3b as get_darkSection,
} from '../../../../theming/sections.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { toFileData1whrjalotozwt as toFileData } from '../../../../../extensions/ProjectAttachment.ext.mjs';
import { LineItemForm37miaqqv1b4u9 as LineItemForm } from '../../../LineItemForm.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from '../../../../dialogs/GenericDialog.mjs';
import { ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance } from '../../../../screens/common/ProjectView.mjs';
import { Data3qblafqxenieu as Data } from '../../../../screens/common/AuthorizedProjectView.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { MultiselectFromItemsDialog1wktb030y4ov as MultiselectFromItemsDialog } from '../../../../dialogs/SelectFromItemsDialog.mjs';
import {
  get_titlelss9nf4gv6ut as get_title_0,
  Page1o437w9xuocrm as Page,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FormSection_Settings_instance;
var FormSection_Changes_instance;
function values() {
  return [FormSection_Settings_getInstance(), FormSection_Changes_getInstance()];
}
function get_entries_0() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var FormSection_entriesInitialized;
function FormSection_initEntries() {
  if (FormSection_entriesInitialized)
    return Unit_instance;
  FormSection_entriesInitialized = true;
  FormSection_Settings_instance = FormSection().oh3('Settings', 0, 'Settings');
  FormSection_Changes_instance = FormSection().oh3('Changes', 1, 'Changes');
}
var $ENTRIES;
function *_generator_invoke__zhh2q8($this, $this$withWrite, num, $completion) {
  var tmp = awaitOnce($this$withWrite, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (num === tmp)
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.vfv_1.mft($this.dh4_1.rh3_1);
  // Inline function 'com.lightningkite.lightningdb.modification' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (ModificationBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(PendingItemChange()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$1);
  this_1.c44(get_itemNumber(it), num);
  var tmp$ret$6 = this_1.m1r();
  var tmp_3 = tmp_1.nen(tmp$ret$6, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, it, $completion) {
  if (it) {
    var tmp = $this.eh4_1.kem($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
var ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda$slambdaClass;
function ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda$slambda() {
  if (ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.eh4_1 = this$0;
      }
      egk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda$slambdaClass = $;
  }
  return ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda$slambdaClass;
}
function ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda$slambda())(this$0);
  var l = (it, $completion) => i.egk(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.fh4_1.gh4($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  set_value($this.fh4_1.xh3_1, false);
  return Unit_instance;
}
function header($this, _this__u8e3s4) {
  var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(3.5));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  view.bb9(get_px(0));
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp_0 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
  $this.ph3_1.og4(view, tmp_0, () => {
    set_value($this.xh3_1, true);
    $this.bh4_1.og5();
    return Unit_instance;
  });
  var tmp_1 = view.kbb(weight(view, 4.0), get_centered(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  view_0.bb9(get_rem(0.6));
  view_0.lbb(get_centered(view_0), expandIcon(view_0, $this.xh3_1));
  var tmp_2 = get_centered(view_0);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.lba(view_1.qb6_1.abf(SubtitleSemantic_getInstance()));
  var tmp_3 = KMutableProperty0();
  var tmp_4 = TextView$_get_content_$ref_4pzcwl(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp$ret$1 = $this$reactiveScope.daj($this.uh3_1).nf9_1;
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_2, view_1);
  var tmp_5 = get_centered(view_0);
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(SmallBodySemantic_getInstance()));
  var tmp_6 = KMutableProperty0();
  var tmp_7 = TextView$_get_content_$ref_4pzcwl_0(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb_0(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var tmp$ret$8 = $this$reactiveScope.daj($this.th3_1).b95().g95_1;
    this_1.set(tmp$ret$8);
    return Unit_instance;
  });
  view_0.hbb(p_2, view_2);
  view_0.lbb(tmp_5, view_2);
  view_0.lbb(view_0.kbb(view_0.kbb(shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.daj($this.ah4_1)), get_centered(view_0)), colored(view_0, AppColors_getInstance().jfz_1.zg9_1)), smallBody(view_0, 'Needs a price or description change'));
  view.hbb(p_0, view_0);
  view.lbb(tmp_1, view_0);
  var tmp_8 = view.kbb(weight(view, 1.0), get_centered(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  view.hbb(p_3, view_3);
  view.lbb(tmp_8, view_3);
  var tmp_9 = view.kbb(weight(view, 1.0), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_4 = view.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.gbb(p_4, view_4);
  view_4.lba(view_4.qb6_1.abf(BodySemantic_getInstance()));
  view_4.dbs(Align_Center_getInstance());
  var tmp_10 = KMutableProperty0();
  var tmp_11 = TextView$_get_content_$ref_4pzcwl_1(view_4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb_1(view_4));
  reactiveScope(view_4, ($this$reactiveScope) => {
    var tmp$ret$22 = $this$reactiveScope.daj($this.wh3_1);
    this_2.set(tmp$ret$22);
    return Unit_instance;
  });
  view.hbb(p_4, view_4);
  view.lbb(tmp_9, view_4);
  var tmp_12 = view.kbb(weight(view, 1.0), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_5 = view.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
  view.gbb(p_5, view_5);
  view_5.lba(view_5.qb6_1.abf(BodySemantic_getInstance()));
  view_5.dbs(Align_Center_getInstance());
  var tmp_13 = KMutableProperty0();
  var tmp_14 = TextView$_get_content_$ref_4pzcwl_2(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb_2(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    var tmp$ret$29 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.daj($this.uh3_1).x91());
    this_3.set(tmp$ret$29);
    return Unit_instance;
  });
  view.hbb(p_5, view_5);
  view.lbb(tmp_12, view_5);
  var tmp_15 = view.kbb(weight(view, 1.0), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_6 = view.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.gbb(p_6, view_6);
  view_6.lba(view_6.qb6_1.abf(BodySemantic_getInstance()));
  view_6.dbs(Align_Center_getInstance());
  var tmp_16 = KMutableProperty0();
  var tmp_17 = TextView$_get_content_$ref_4pzcwl_3(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_4 = getPropertyCallableRef('content', 0, tmp_16, tmp_17, TextView$_set_content_$ref_pketfb_3(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    var tmp$ret$36 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.daj($this.uh3_1).jf9_1.q91());
    this_4.set(tmp$ret$36);
    return Unit_instance;
  });
  view.hbb(p_6, view_6);
  view.lbb(tmp_15, view_6);
  var tmp_18 = view.kbb(weight(view, 1.0), get_centered(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_7 = view.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
  view.gbb(p_7, view_7);
  var tmp_19 = get_centered(view_7);
  view_7.lbb(tmp_19, renderPriceChange(view_7, VOID, ($this$renderPriceChange) => {
    var d = $this$renderPriceChange.daj($this.th3_1);
    var tmp;
    if (d.g72_1) {
      tmp = MonetaryValue__unaryMinus_impl_x5smq0($this$renderPriceChange.daj($this.uh3_1).jf9_1.l6k_1);
    } else {
      var tmp0_elvis_lhs = d.f72_1;
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
        tmp_0 = Companion_instance.r91(0n);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    }
    var tmp_2 = tmp;
    return tmp_2 == null ? null : new (MonetaryValue())(tmp_2);
  }));
  view.hbb(p_7, view_7);
  view.lbb(tmp_18, view_7);
  var tmp_20 = view.kbb(weight(view, 1.0), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_8 = view.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view : tmp0_elvis_lhs_8;
  view.gbb(p_8, view_8);
  view_8.lba(view_8.qb6_1.abf(BodySemantic_getInstance()));
  view_8.dbs(Align_Center_getInstance());
  var tmp_21 = KMutableProperty0();
  var tmp_22 = TextView$_get_content_$ref_4pzcwl_4(view_8);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_5 = getPropertyCallableRef('content', 0, tmp_21, tmp_22, TextView$_set_content_$ref_pketfb_4(view_8));
  reactiveScope(view_8, ($this$reactiveScope) => {
    var d = $this$reactiveScope.daj($this.th3_1);
    var tmp;
    if (d.g72_1) {
      tmp = 0;
    } else {
      var tmp_0 = $this$reactiveScope.daj($this.uh3_1).x91();
      var tmp0_elvis_lhs = d.f72_1;
      var tmp_1;
      var tmp_2 = tmp0_elvis_lhs;
      if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
        tmp_1 = Companion_instance.r91(0n);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp = new (MonetaryValue())(MonetaryValue__plus_impl_c1ylt(tmp_0, tmp_1));
    }
    var tmp$ret$46 = toString(tmp);
    this_5.set(tmp$ret$46);
    return Unit_instance;
  });
  view.hbb(p_8, view_8);
  view.lbb(tmp_20, view_8);
  _this__u8e3s4.hbb(p, view);
  _this__u8e3s4.lbb(tmp, view);
}
function inputFields($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  // Inline function 'com.crowpay.views.components.requiredField' call
  var label = 'Price Change (Dollars)';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  view_0.bb9(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.bb9(get_AppDimensions().rg2_1);
  view_1.lbb(get_centered(view_1), bodyBold(view_1, label));
  view_1.lbb(colored(view_1, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_1, '*'));
  view_0.hbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = view_0.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_0 = $this.th3_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(PendingItemChange()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$5);
  var tmp$ret$7 = get_priceChange(it);
  var priceChange = lensPath(this_0, tmp$ret$7);
  assertReactive(priceChange, 'Price change cannot reduce the work item below what has already been paid out.', VOID, ($this$assertReactive, it) => {
    var tmp = it;
    var tmp0_elvis_lhs = tmp == null ? null : tmp.y5r_1;
    var tmp_0;
    var tmp_1 = tmp0_elvis_lhs;
    if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
      tmp_0 = Companion_instance.r91(0n);
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return MonetaryValue__compareTo_impl_w7ul1r(MonetaryValue__plus_impl_c1ylt(tmp_0, $this$assertReactive.daj($this.uh3_1).jf9_1.q91()), Companion_instance.r91(0n)) >= 0;
  });
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = view_0.dbb_1;
  var tmp_1 = view_0;
  tmp_1.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    dynamicTheme(_this__u8e3s4, ($this$dynamicTheme) => $this$dynamicTheme.daj($this.ah4_1) ? InvalidSemantic_getInstance() : null);
    return Unit_instance;
  };
  var tmp_2 = Companion_getInstance_1();
  // Inline function 'com.crowpay.views.components.monetaryValueInput' call
  // Inline function 'kotlin.also' call
  var this_1 = new (MonetaryValueInput())(view_0);
  this_1.vcl('Price Change');
  view_0.zah(this_1.ig9_1, zeroToNull(priceChange));
  $this.bh4_1.ng5(this_1.lg9_1);
  var tmp$ret$13 = this_1.lg9_1;
  var tmp$ret$14 = view_0.lbb(tmp_2, tmp$ret$13);
  view_0.lbb(tmp, tmp$ret$14);
  view.hbb(p_0, view_0);
  // Inline function 'com.crowpay.views.components.field2' call
  var label_0 = 'Updated Description';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_2 = view.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.gbb(p_2, view_2);
  view_2.zbm(true);
  view_2.bb9(get_AppDimensions().pg2_1);
  bodyBold(view_2, label_0);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_3 = view_2.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_2 = $this.th3_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_4 = serializerOrContextual(createKType(getKClass(PendingItemChange()), arrayOf([]), false));
  var tmp$ret$21 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$21);
  var tmp$ret$23 = get_updatedDescription(it_0);
  var desc = lensPath(this_2, tmp$ret$23);
  if (get_viewIsWide(view_2)) {
    sizeConstraints(view_2, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(7));
  }
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev_0 = view_2.dbb_1;
  var tmp_5 = view_2;
  tmp_5.dbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev_0;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    dynamicTheme(_this__u8e3s4, ($this$dynamicTheme) => $this$dynamicTheme.daj($this.ah4_1) ? InvalidSemantic_getInstance() : null);
    return Unit_instance;
  };
  var tmp_6 = Companion_getInstance_1();
  // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextArea())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.vcl('Updated Description');
  view_3.zah(view_3.scl_1, nullToBlank(desc));
  view_2.hbb(p_3, view_3);
  var tmp$ret$30 = view_2.lbb(tmp_6, view_3);
  view_2.lbb(tmp_3, tmp$ret$30);
  view_2.lbb(view_2.jbb(SubtextSemantic_getInstance()), errorText(view_2));
  view.hbb(p_2, view_2);
  view.lbb(view.kbb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj($this.ah4_1)), colored(view, AppColors_getInstance().jfz_1.zg9_1)), smallBody(view, "Enter a price change or an updated description. A change with neither can't be submitted."));
  _this__u8e3s4.hbb(p, view);
  return view;
}
function actionBar($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  view.bb9(get_AppDimensions().kg2_1);
  view.gba(get_AppDimensions().kg2_1);
  var tmp = get_deleteButton(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.lbb(get_centered(view_1), icon(view_1, resize(get_trash(Companion_getInstance_0()), get_rem(0.8)), 'Remove'));
  view_1.lbb(get_centered(view_1), body(view_1, 'Delete'));
  view_0.hbb(p_1, view_1);
  onClick(view_0, VOID, VOID, ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda_0($this));
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  var tmp_0 = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Space())(view.pc());
  var tmp0_elvis_lhs_2 = view.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.gbb(p_2, view_2);
  view.hbb(p_2, view_2);
  view.lbb(tmp_0, view_2);
  var tmp_1 = get_secondaryButton(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  specCenteredText(view_3, 'Discard');
  onClick(view_3, VOID, VOID, ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda_2($this));
  view.hbb(p_3, view_3);
  view.lbb(tmp_1, view_3);
  var tmp_2 = get_primaryButton(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Button())(view.pc());
  var tmp0_elvis_lhs_4 = view.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.gbb(p_4, view_4);
  var tmp_3 = KMutableProperty0();
  var tmp_4 = Button$_get_enabled_$ref_61t7nx(view_4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_3, tmp_4, Button$_set_enabled_$ref_o8kynz(view_4));
  reactiveScope(view_4, ($this$reactiveScope) => {
    var tmp$ret$13 = $this$reactiveScope.daj(get_issues($this.th3_1)).i1();
    this_0.set(tmp$ret$13);
    return Unit_instance;
  });
  specCenteredText(view_4, 'Save');
  onClick(view_4, VOID, VOID, ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda_4($this));
  view.hbb(p_4, view_4);
  view.lbb(tmp_2, view_4);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function *_generator_delete__spiywt($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfv_1.mft($this.rh3_1).kem($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.ch4_1.hh4($this, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  $this.l6();
  return Unit_instance;
}
function *_generator_save__qhzefp($this, $completion) {
  var tmp = awaitOnce(get_session(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = pushChanges($this.th3_1, tmp.vfv_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function ChangeOrderForm2$ChangeLineItemForm$itemNumber$lambda(it) {
  return it.m72_1;
}
var ChangeOrderForm2$ChangeLineItemForm$itemNumber$slambdaClass;
function ChangeOrderForm2$ChangeLineItemForm$itemNumber$slambda() {
  if (ChangeOrderForm2$ChangeLineItemForm$itemNumber$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.dh4_1 = this$0;
      }
      ih4($this$withWrite, num, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$withWrite, num), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.ih4(tmp, (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ChangeOrderForm2$ChangeLineItemForm$itemNumber$slambdaClass = $;
  }
  return ChangeOrderForm2$ChangeLineItemForm$itemNumber$slambdaClass;
}
function ChangeOrderForm2$ChangeLineItemForm$itemNumber$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$ChangeLineItemForm$itemNumber$slambda())(this$0);
  var l = ($this$withWrite, num, $completion) => i.ih4($this$withWrite, num, $completion);
  l.$arity = 2;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var ChangeOrderForm2$ChangeLineItemForm$actionBar$slambdaClass;
function ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda() {
  if (ChangeOrderForm2$ChangeLineItemForm$actionBar$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.jh4_1 = this$0;
      }
      uao($completion) {
        var tmp = get_dialogStack();
        var tmp0_confirmationTheme = DangerButtonSemantic_getInstance();
        tmp.zgd(new (GenericConfirmationDialog())('Delete Change Item?', 'This cannot be undone.', VOID, 'Delete Item', VOID, tmp0_confirmationTheme, VOID, VOID, VOID, VOID, ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda$slambda_0(this.jh4_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$ChangeLineItemForm$actionBar$slambdaClass = $;
  }
  return ChangeOrderForm2$ChangeLineItemForm$actionBar$slambdaClass;
}
function ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ChangeOrderForm2$ChangeLineItemForm$actionBar$slambdaClass_0;
function ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda_1() {
  if (ChangeOrderForm2$ChangeLineItemForm$actionBar$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.kh4_1 = this$0;
      }
      uao($completion) {
        this.kh4_1.th3_1.nai();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$ChangeLineItemForm$actionBar$slambdaClass_0 = $;
  }
  return ChangeOrderForm2$ChangeLineItemForm$actionBar$slambdaClass_0;
}
function ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda_2(this$0) {
  var i = new (ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var ChangeOrderForm2$ChangeLineItemForm$actionBar$slambdaClass_1;
function ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda_3() {
  if (ChangeOrderForm2$ChangeLineItemForm$actionBar$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.fh4_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$ChangeLineItemForm$actionBar$slambdaClass_1 = $;
  }
  return ChangeOrderForm2$ChangeLineItemForm$actionBar$slambdaClass_1;
}
function ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda_4(this$0) {
  var i = new (ChangeOrderForm2$ChangeLineItemForm$actionBar$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_6(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_6(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_2($this, $this$withWrite, num, $completion) {
  var tmp = awaitOnce($this$withWrite, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (num === tmp)
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.ufv_1.mft($this.vh4_1.lh4_1);
  // Inline function 'com.lightningkite.lightningdb.modification' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (ModificationBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(PendingLineItem()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$1);
  this_1.c44(get_itemNumber_0(it), num);
  var tmp$ret$6 = this_1.m1r();
  var tmp_3 = tmp_1.nen(tmp$ret$6, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, it, $completion) {
  if (it) {
    var tmp = $this.wh4_1.kem($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
var ChangeOrderForm2$NewLineItemForm$actionBar$slambda$slambdaClass;
function ChangeOrderForm2$NewLineItemForm$actionBar$slambda$slambda() {
  if (ChangeOrderForm2$NewLineItemForm$actionBar$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.wh4_1 = this$0;
      }
      egk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$NewLineItemForm$actionBar$slambda$slambdaClass = $;
  }
  return ChangeOrderForm2$NewLineItemForm$actionBar$slambda$slambdaClass;
}
function ChangeOrderForm2$NewLineItemForm$actionBar$slambda$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$NewLineItemForm$actionBar$slambda$slambda())(this$0);
  var l = (it, $completion) => i.egk(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_notNullContractor();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.yh4_1.oh4_1.ng8_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.yh4_1.oh4_1.og8_1;
  var tmp_3 = await_0(this_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = tmp_3;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.yh4_1.oh4_1.qg8_1;
  var tmp_5 = await_0(this_3, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp_6 = tmp_5.y5r_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = $this.yh4_1.oh4_1.mg8_1;
  var tmp_7 = await_0(this_4, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var tmp_8 = tmp_7;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_5 = $this.yh4_1.oh4_1.gg8_1;
  var tmp_9 = await_0(this_5, $completion);
  if (tmp_9 === get_COROUTINE_SUSPENDED())
    tmp_9 = yield tmp_9;
  var tmp$ret$5 = tmp_9;
  var tmp_10 = resolveProjectAttachments(tmp$ret$5, $completion);
  if (tmp_10 === get_COROUTINE_SUSPENDED())
    tmp_10 = yield tmp_10;
  confirmNewSpecDialog($this.xh4_1, new (Specification())(VOID, tmp_0, VOID, tmp_2, tmp_4, tmp_6, tmp_8, tmp_10));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = $this.zh4_1.gh4($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  set_value($this.zh4_1.th4_1, false);
  return Unit_instance;
}
function header_0($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  view.bb9(get_dp(0));
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var tmp = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
  $this.ph4_1.og4(view, tmp, () => {
    set_value($this.th4_1, true);
    $this.oh4_1.sg8_1.og5();
    return Unit_instance;
  });
  var tmp_0 = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$1 = view.jbb(ButtonSemantic_getInstance());
  var tmp_1 = view.kbb(view.kbb(tmp_0, tmp$ret$1), get_unpadded(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  var tmp_2 = sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(3.5));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.bb9(get_dp(0));
  var tmp_3 = view_1.kbb(weight(view_1, 4.0), get_centered(view_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.zbm(false);
  view_2.lbb(get_centered(view_2), expandIcon(view_2, $this.th4_1));
  var tmp_4 = get_centered(view_2);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.lba(view_3.qb6_1.abf(SubtitleSemantic_getInstance()));
  var tmp_5 = KMutableProperty0();
  var tmp_6 = TextView$_get_content_$ref_4pzcwl_7(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb_7(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    // Inline function 'kotlin.text.ifBlank' call
    var this_1 = $this$reactiveScope.daj($this.oh4_1.kg8_1);
    var tmp;
    if (isBlank(this_1)) {
      tmp = 'New Item';
    } else {
      tmp = this_1;
    }
    var tmp$ret$4 = tmp;
    this_0.set(tmp$ret$4);
    return Unit_instance;
  });
  view_2.hbb(p_3, view_3);
  view_2.lbb(tmp_4, view_3);
  view_2.lbb(get_centered(view_2), smallBody(view_2, 'New'));
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_3, view_2);
  var tmp_7 = view_1.kbb(weight(view_1, 1.0), get_centered(view_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Frame())(view_1.pc());
  var tmp0_elvis_lhs_4 = view_1.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
  view_1.gbb(p_4, view_4);
  var tmp_8 = view_4.kbb(colored(view_4, AppColors_getInstance().ffz_1.zg9_1), get_centered(view_4));
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (IconView())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  var tmp_9 = KMutableProperty0();
  var tmp_10 = IconView$_get_visible_$ref_7ldslk(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('visible', 0, tmp_9, tmp_10, IconView$_set_visible_$ref_mp0dqc(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    var tmp$ret$15 = !!($this$reactiveScope.daj($this.sh4_1) & !$this$reactiveScope.daj($this.uh4_1.nf4_1));
    this_1.set(tmp$ret$15);
    return Unit_instance;
  });
  view_5.sbt(get_linked(Companion_getInstance_0()));
  view_4.hbb(p_5, view_5);
  view_4.lbb(tmp_8, view_5);
  view_1.hbb(p_4, view_4);
  view_1.lbb(tmp_7, view_4);
  var tmp_11 = view_1.kbb(weight(view_1, 1.0), get_centered(view_1));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_6 = view_1.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_1 : tmp0_elvis_lhs_6;
  view_1.gbb(p_6, view_6);
  view_6.lba(view_6.qb6_1.abf(BodySemantic_getInstance()));
  view_6.dbs(Align_Center_getInstance());
  var tmp_12 = KMutableProperty0();
  var tmp_13 = TextView$_get_content_$ref_4pzcwl_8(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb_8(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    var tmp$ret$23 = $this$reactiveScope.daj($this.rh4_1);
    this_2.set(tmp$ret$23);
    return Unit_instance;
  });
  view_1.hbb(p_6, view_6);
  view_1.lbb(tmp_11, view_6);
  var tmp_14 = view_1.kbb(weight(view_1, 1.0), get_centered(view_1));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_7 = view_1.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_1 : tmp0_elvis_lhs_7;
  view_1.gbb(p_7, view_7);
  view_7.lba(view_7.qb6_1.abf(BodySemantic_getInstance()));
  view_7.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_15 = view_7.vb5_1;
  var tmp_16;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('$0.00') === 0) {
    tmp_16 = '\xA0';
  } else {
    tmp_16 = '$0.00';
  }
  tmp_15.hbu(tmp_16);
  view_1.hbb(p_7, view_7);
  view_1.lbb(tmp_14, view_7);
  var tmp_17 = view_1.kbb(weight(view_1, 1.0), get_centered(view_1));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_8 = view_1.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_1 : tmp0_elvis_lhs_8;
  view_1.gbb(p_8, view_8);
  view_8.lba(view_8.qb6_1.abf(BodySemantic_getInstance()));
  view_8.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_18 = view_8.vb5_1;
  var tmp_19;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('$0.00') === 0) {
    tmp_19 = '\xA0';
  } else {
    tmp_19 = '$0.00';
  }
  tmp_18.hbu(tmp_19);
  view_1.hbb(p_8, view_8);
  view_1.lbb(tmp_17, view_8);
  var tmp_20 = view_1.kbb(weight(view_1, 1.0), get_centered(view_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (Frame())(view_1.pc());
  var tmp0_elvis_lhs_9 = view_1.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_1 : tmp0_elvis_lhs_9;
  view_1.gbb(p_9, view_9);
  var tmp_21 = get_centered(view_9);
  view_9.lbb(tmp_21, renderPriceChange(view_9, VOID, ($this$renderPriceChange) => new (MonetaryValue())($this$renderPriceChange.daj($this.mh4_1).y75_1)));
  view_1.hbb(p_9, view_9);
  view_1.lbb(tmp_20, view_9);
  var tmp_22 = view_1.kbb(weight(view_1, 1.0), get_centered(view_1));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_10 = view_1.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_1 : tmp0_elvis_lhs_10;
  view_1.gbb(p_10, view_10);
  view_10.lba(view_10.qb6_1.abf(BodySemantic_getInstance()));
  view_10.dbs(Align_Center_getInstance());
  var tmp_23 = KMutableProperty0();
  var tmp_24 = TextView$_get_content_$ref_4pzcwl_9(view_10);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_23, tmp_24, TextView$_set_content_$ref_pketfb_9(view_10));
  reactiveScope(view_10, ($this$reactiveScope) => {
    var tmp$ret$47 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.daj($this.mh4_1).y75_1);
    this_3.set(tmp$ret$47);
    return Unit_instance;
  });
  view_1.hbb(p_10, view_10);
  view_1.lbb(tmp_22, view_10);
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_2, view_1);
  view_0.obg(expandAction($this.th4_1));
  view.hbb(p_0, view_0);
  view.lbb(tmp_1, view_0);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function actionBar_0($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  view.bb9(get_AppDimensions().kg2_1);
  view.gba(get_AppDimensions().kg2_1);
  var tmp = get_deleteButton(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.lbb(get_centered(view_1), icon(view_1, resize(get_trash(Companion_getInstance_0()), get_rem(0.8)), 'Remove'));
  view_1.lbb(get_centered(view_1), body(view_1, 'Delete'));
  view_0.hbb(p_1, view_1);
  onClick(view_0, VOID, VOID, ChangeOrderForm2$NewLineItemForm$actionBar$slambda_0($this));
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  var tmp_0 = get_textButton(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Button())(view.pc());
  var tmp0_elvis_lhs_2 = view.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.gbb(p_2, view_2);
  var tmp_1 = KMutableProperty0();
  var tmp_2 = Button$_get_enabled_$ref_61t7nx_0(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_1, tmp_2, Button$_set_enabled_$ref_o8kynz_0(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_1 = $this$reactiveScope.daj($this.oh4_1.ng8_1);
    var tmp$ret$8 = charSequenceLength(this_1) > 0;
    this_0.set(tmp$ret$8);
    return Unit_instance;
  });
  specCenteredText(view_2, 'Save As Spec');
  onClick(view_2, VOID, VOID, ChangeOrderForm2$NewLineItemForm$actionBar$slambda_2(view_2, $this));
  view.hbb(p_2, view_2);
  view.lbb(tmp_0, view_2);
  var tmp_3 = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Space())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  view.hbb(p_3, view_3);
  view.lbb(tmp_3, view_3);
  var tmp_4 = get_secondaryButton(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Button())(view.pc());
  var tmp0_elvis_lhs_4 = view.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.gbb(p_4, view_4);
  specCenteredText(view_4, 'Discard');
  onClick(view_4, VOID, VOID, ChangeOrderForm2$NewLineItemForm$actionBar$slambda_4($this));
  view.hbb(p_4, view_4);
  view.lbb(tmp_4, view_4);
  var tmp_5 = get_primaryButton(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Button())(view.pc());
  var tmp0_elvis_lhs_5 = view.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
  view.gbb(p_5, view_5);
  specCenteredText(view_5, 'Save');
  onClick(view_5, VOID, VOID, ChangeOrderForm2$NewLineItemForm$actionBar$slambda_6($this));
  view.hbb(p_5, view_5);
  view.lbb(tmp_5, view_5);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function changeForm($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  var tmp = view.kbb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj($this.uh4_1.ff4_1)), get_compact(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  var tmp_0 = get_centered(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Checkbox())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  var tmp_1 = KMutableProperty0();
  var tmp_2 = Checkbox$_get_enabled_$ref_57hbqa(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_1, tmp_2, Checkbox$_set_enabled_$ref_zhvi26(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp$ret$0 = !$this$reactiveScope.daj($this.uh4_1.df4_1);
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view_1.zah(view_1.ebk_1, $this.sh4_1);
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_0, view_1);
  view_0.lbb(get_centered(view_0), body(view_0, 'Linked'));
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  render($this.oh4_1, view);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function *_generator_delete__spiywt_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.ufv_1.mft($this.lh4_1).kem($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.uh4_1.hh4($this, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  $this.l6();
  return Unit_instance;
}
function *_generator_save__qhzefp_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = pushChanges($this.mh4_1, tmp$ret$0.ufv_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function ChangeOrderForm2$NewLineItemForm$form$lambda($this$LineItemForm) {
  return false;
}
function ChangeOrderForm2$NewLineItemForm$form$lambda_0(it) {
  return !it;
}
function ChangeOrderForm2$NewLineItemForm$itemNumber$lambda(it) {
  return it.g76_1;
}
var ChangeOrderForm2$NewLineItemForm$itemNumber$slambdaClass;
function ChangeOrderForm2$NewLineItemForm$itemNumber$slambda() {
  if (ChangeOrderForm2$NewLineItemForm$itemNumber$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.vh4_1 = this$0;
      }
      ih4($this$withWrite, num, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$withWrite, num), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.ih4(tmp, (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ChangeOrderForm2$NewLineItemForm$itemNumber$slambdaClass = $;
  }
  return ChangeOrderForm2$NewLineItemForm$itemNumber$slambdaClass;
}
function ChangeOrderForm2$NewLineItemForm$itemNumber$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$NewLineItemForm$itemNumber$slambda())(this$0);
  var l = ($this$withWrite, num, $completion) => i.ih4($this$withWrite, num, $completion);
  l.$arity = 2;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_7(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_7(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function IconView$_get_visible_$ref_7ldslk(p0) {
  return () => p0.ab9();
}
function IconView$_set_visible_$ref_mp0dqc(p0) {
  return (_this__u8e3s4) => {
    p0.zb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_8(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_8(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_9(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_9(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass;
function ChangeOrderForm2$NewLineItemForm$actionBar$slambda() {
  if (ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ah5_1 = this$0;
      }
      uao($completion) {
        var tmp = get_dialogStack();
        var tmp0_confirmationTheme = DangerButtonSemantic_getInstance();
        tmp.zgd(new (GenericConfirmationDialog())('Delete Change Item?', 'This cannot be undone.', VOID, 'Delete Item', VOID, tmp0_confirmationTheme, VOID, VOID, VOID, VOID, ChangeOrderForm2$NewLineItemForm$actionBar$slambda$slambda_0(this.ah5_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass = $;
  }
  return ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass;
}
function ChangeOrderForm2$NewLineItemForm$actionBar$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$NewLineItemForm$actionBar$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass_0;
function ChangeOrderForm2$NewLineItemForm$actionBar$slambda_1() {
  if (ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.xh4_1 = $$this$button;
        this.yh4_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass_0 = $;
  }
  return ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass_0;
}
function ChangeOrderForm2$NewLineItemForm$actionBar$slambda_2($$this$button, this$0) {
  var i = new (ChangeOrderForm2$NewLineItemForm$actionBar$slambda_1())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass_1;
function ChangeOrderForm2$NewLineItemForm$actionBar$slambda_3() {
  if (ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.bh5_1 = this$0;
      }
      uao($completion) {
        this.bh5_1.mh4_1.nai();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass_1 = $;
  }
  return ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass_1;
}
function ChangeOrderForm2$NewLineItemForm$actionBar$slambda_4(this$0) {
  var i = new (ChangeOrderForm2$NewLineItemForm$actionBar$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass_2;
function ChangeOrderForm2$NewLineItemForm$actionBar$slambda_5() {
  if (ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0) {
        this.zh4_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass_2 = $;
  }
  return ChangeOrderForm2$NewLineItemForm$actionBar$slambdaClass_2;
}
function ChangeOrderForm2$NewLineItemForm$actionBar$slambda_6(this$0) {
  var i = new (ChangeOrderForm2$NewLineItemForm$actionBar$slambda_5())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Checkbox$_get_enabled_$ref_57hbqa(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Checkbox.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Checkbox$_set_enabled_$ref_zhvi26(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Checkbox.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_10(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_10(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_11(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_11(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_6($this, $this$interceptWrite, link, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ch5_1.jf4_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp_0 = element.sh4_1.iah(link, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  var tmp_1 = $this$interceptWrite.iah(link, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $this$interceptWrite, cardinal, $completion) {
  if (!cardinal) {
    var tmp = $this.dh5_1.ff4_1.iah(false, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = $this.dh5_1.ef4_1.iah(false, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  var tmp_1 = $this$interceptWrite.iah(cardinal, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.ufv_1;
  var tmp0_limit = 2147483647;
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(PendingLineItem()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$1);
  this_1.l4a(get_created_0(it));
  // Inline function 'com.lightningkite.lightningdb.Query' call
  var orderBy = this_1.m1r();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(PendingLineItem()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$7);
  var tmp$ret$9 = eq(get_changeRequest_0(it_0), $this.eh5_1.zf3_1);
  var tmp$ret$10 = new (Query())(tmp$ret$9, orderBy, 0, tmp0_limit);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = tmp_0.heo(tmp$ret$10);
  var tmp_3 = await_0(this_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'kotlin.collections.map' call
  var this_3 = tmp_3;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_3, 10));
  var _iterator__ex2g4s = this_3.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp_4 = $this.eh5_1.fh5(item, $this.eh5_1.hf4_1, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    var tmp$ret$12 = tmp_4;
    destination.v(tmp$ret$12);
  }
  return destination;
}
function *_generator_invoke__zhh2q8_9($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfv_1;
  var tmp0_limit = 2147483647;
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(PendingItemChange()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$1);
  this_1.l4a(get_created(it));
  // Inline function 'com.lightningkite.lightningdb.Query' call
  var orderBy = this_1.m1r();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(PendingItemChange()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$7);
  var tmp$ret$9 = eq(get_changeRequest(it_0), $this.gh5_1.zf3_1);
  var tmp$ret$10 = new (Query())(tmp$ret$9, orderBy, 0, tmp0_limit);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = tmp_0.heo(tmp$ret$10);
  var tmp_3 = await_0(this_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'kotlin.collections.map' call
  var this_3 = tmp_3;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_3, 10));
  var _iterator__ex2g4s = this_3.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp_4 = $this.gh5_1.hh5(item, $this.gh5_1.hf4_1, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    var tmp$ret$12 = tmp_4;
    destination.v(tmp$ret$12);
  }
  return destination;
}
function *_generator_invoke__zhh2q8_10($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ih5_1.nf4_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return it.d58(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function *_generator_invoke__zhh2q8_11($this, $this$async, $completion) {
  var tmp = $this.jh5_1.gh4($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_12($this, $this$async, $completion) {
  var tmp = $this.kh5_1.gh4($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_13($this, $this$coroutineScope, $completion) {
  var tmp = modify($this.lh5_1.bf4_1, ChangeOrderForm2$save$slambda$slambda_0($this.lh5_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  var tmp_1 = pushChanges($this.lh5_1.bf4_1, tmp$ret$0.jfv_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  if (!$this.mh5_1)
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.lh5_1.jf4_1;
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  // Inline function 'kotlin.collections.map' call
  var this_2 = tmp_2;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$2 = async($this$coroutineScope, VOID, VOID, ChangeOrderForm2$save$slambda$slambda_2(item));
    destination.v(tmp$ret$2);
  }
  var tmp_3 = awaitAll(destination, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.lh5_1.kf4_1;
  var tmp_4 = await_0(this_3, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  // Inline function 'kotlin.collections.map' call
  var this_4 = tmp_4;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(this_4, 10));
  var _iterator__ex2g4s_0 = this_4.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item_0 = _iterator__ex2g4s_0.o1();
    var tmp$ret$6 = async($this$coroutineScope, VOID, VOID, ChangeOrderForm2$save$slambda$slambda_4(item_0));
    destination_0.v(tmp$ret$6);
  }
  var tmp_5 = awaitAll(destination_0, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return Unit_instance;
}
var ChangeOrderForm2$save$slambda$slambdaClass;
function ChangeOrderForm2$save$slambda$slambda() {
  if (ChangeOrderForm2$save$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ih5_1 = this$0;
      }
      nh5(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.nh5(p1 instanceof ChangeRequest() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$save$slambda$slambdaClass = $;
  }
  return ChangeOrderForm2$save$slambda$slambdaClass;
}
function ChangeOrderForm2$save$slambda$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$save$slambda$slambda())(this$0);
  var l = (it, $completion) => i.nh5(it, $completion);
  l.$arity = 1;
  return l;
}
var ChangeOrderForm2$save$slambda$slambdaClass_0;
function ChangeOrderForm2$save$slambda$slambda_1() {
  if (ChangeOrderForm2$save$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($it) {
        this.jh5_1 = $it;
      }
      yah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$save$slambda$slambdaClass_0 = $;
  }
  return ChangeOrderForm2$save$slambda$slambdaClass_0;
}
function ChangeOrderForm2$save$slambda$slambda_2($it) {
  var i = new (ChangeOrderForm2$save$slambda$slambda_1())($it);
  var l = ($this$async, $completion) => i.yah($this$async, $completion);
  l.$arity = 1;
  return l;
}
var ChangeOrderForm2$save$slambda$slambdaClass_1;
function ChangeOrderForm2$save$slambda$slambda_3() {
  if (ChangeOrderForm2$save$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($it) {
        this.kh5_1 = $it;
      }
      yah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$save$slambda$slambdaClass_1 = $;
  }
  return ChangeOrderForm2$save$slambda$slambdaClass_1;
}
function ChangeOrderForm2$save$slambda$slambda_4($it) {
  var i = new (ChangeOrderForm2$save$slambda$slambda_3())($it);
  var l = ($this$async, $completion) => i.yah($this$async, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_14($this, $this$coroutineScope, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.jfv_1.mft($this.oh5_1.zf3_1).kem($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_15($this, $this$launch, $completion) {
  var tmp = verifyContractor($this.ph5_1, MemberRole_Manager_getInstance(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = awaitOnce($this.qh5_1.lf4_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = delay(100n, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  $this.qh5_1.hf4_1 = true;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.rh5_1.bf4_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.rh5_1.cf4_1;
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = tmp_2;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.rh5_1.lf4_1;
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = tmp_4.p1() + 1 | 0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.sh5_1;
  var tmp_6 = await_0(this_3, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var tmp$ret$3 = tmp_6;
  tmp.zgd($this.rh5_1.th5(tmp_1, tmp_3, tmp_5, tmp$ret$3));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_17($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.uh5_1.bf4_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.uh5_1.cf4_1;
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = tmp_2;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.uh5_1.lf4_1;
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = tmp_4.p1() + 1 | 0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.vh5_1;
  var tmp_6 = await_0(this_3, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var tmp$ret$3 = tmp_6;
  tmp.zgd($this.uh5_1.wh5(tmp_1, tmp_3, tmp_5, tmp$ret$3));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_18($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.ufv_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.xh5_1.lfy();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp0_project = tmp_1.v7a_1;
  var tmp1_changeRequest = $this.xh5_1.zf3_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.xh5_1.cf4_1;
  var tmp_2 = await_0(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = tmp_2;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.xh5_1.lf4_1;
  var tmp_4 = await_0(this_3, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp2_itemNumber = tmp_3 + '.' + (tmp_4.p1() + 1 | 0);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = $this.xh5_1.ff4_1;
  var tmp_5 = await_0(this_4, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp3_linked = tmp_5;
  var tmp_6 = tmp_0.lft(new (PendingLineItem())(VOID, tmp0_project, tmp1_changeRequest, VOID, VOID, VOID, VOID, tmp3_linked, VOID, VOID, VOID, VOID, VOID, tmp2_itemNumber), $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_19($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.yh5_1.jf4_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0 = tmp;
  var tmp$ret$1;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp_0;
    if (isInterface(tmp0, Collection())) {
      tmp_0 = tmp0.i1();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$1 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = element.mh4_1.aak();
      var tmp_1 = await_0(this_1, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      if (!(tmp_1.e76_1 == null)) {
        tmp$ret$1 = true;
        break $l$block_0;
      }
    }
    tmp$ret$1 = false;
  }
  if (tmp$ret$1) {
    var tmp_2 = get_mainPageNavigator($this.zh5_1);
    goBackOrReplaceWith(tmp_2, ChangeOrderForm2$renderWide$slambda$lambda);
    return Unit_instance;
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.yh5_1.kf4_1;
  var tmp_3 = await_0(this_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp0_0 = tmp_3;
  var tmp$ret$5;
  $l$block_2: {
    // Inline function 'kotlin.collections.any' call
    var tmp_4;
    if (isInterface(tmp0_0, Collection())) {
      tmp_4 = tmp0_0.i1();
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp$ret$5 = false;
      break $l$block_2;
    }
    var _iterator__ex2g4s_0 = tmp0_0.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element_0 = _iterator__ex2g4s_0.o1();
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_3 = element_0.th3_1.aak();
      var tmp_5 = await_0(this_3, $completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
      if (!(tmp_5.i72_1 == null)) {
        tmp$ret$5 = true;
        break $l$block_2;
      }
    }
    tmp$ret$5 = false;
  }
  if (tmp$ret$5) {
    var tmp_6 = get_mainPageNavigator($this.zh5_1);
    goBackOrReplaceWith(tmp_6, ChangeOrderForm2$renderWide$slambda$lambda_0);
  }
  return Unit_instance;
}
function ChangeOrderForm2$renderWide$slambda$lambda() {
  return new (LandingScreen())();
}
function ChangeOrderForm2$renderWide$slambda$lambda_0() {
  return new (LandingScreen())();
}
function *_generator_invoke__zhh2q8_20($this, $this$launch, $completion) {
  var tmp = awaitOnce($this.ah6_1.lf4_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = delay(500n, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  $this.ah6_1.hf4_1 = true;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_21($this, selected, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfv_1;
  // Inline function 'kotlin.collections.map' call
  var this_1 = withIndex(selected);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var index = item.cf();
    var item_0 = item.df();
    var tmp$ret$1 = new (PendingItemChange())(VOID, $this.bh6_1.p57_1, $this.bh6_1.o57_1, item_0.mf9_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $this.ch6_1 + '.' + ($this.dh6_1 + index | 0));
    destination.v(tmp$ret$1);
  }
  var tmp_1 = tmp_0.ceo(destination, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_22($this, selected, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.vfv_1;
  // Inline function 'kotlin.collections.map' call
  var this_1 = withIndex(selected);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var index = item.cf();
    var itemToRemove = item.df();
    var tmp0_project = $this.eh6_1.p57_1;
    var tmp1_changeRequest = $this.eh6_1.o57_1;
    var tmp2_itemId = itemToRemove.mf9_1;
    var tmp3_itemNumber = $this.fh6_1 + '.' + ($this.gh6_1 + index | 0);
    var tmp$ret$1 = new (PendingItemChange())(VOID, tmp0_project, tmp1_changeRequest, tmp2_itemId, VOID, null, true, VOID, VOID, VOID, VOID, VOID, tmp3_itemNumber);
    destination.v(tmp$ret$1);
  }
  var tmp_1 = tmp_0.ceo(destination, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_23($this, $completion) {
  var tmp = $this.hh6_1.ih6(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_24($this, $completion) {
  var tmp = $this.jh6_1.ih6(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = get_mainPageNavigator($this.kh6_1);
  goBackOrReplaceWith(tmp_0, ChangeOrderForm2$actionBar$saveAndCloseButton$slambda$lambda);
  return Unit_instance;
}
function ChangeOrderForm2$actionBar$saveAndCloseButton$slambda$lambda() {
  return new (LandingScreen())();
}
var ChangeOrderForm2$actionBar$discardButton$slambda$slambdaClass;
function ChangeOrderForm2$actionBar$discardButton$slambda$slambda() {
  if (ChangeOrderForm2$actionBar$discardButton$slambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.lh6_1 = $$this$button;
        this.mh6_1 = this$0;
      }
      uao($completion) {
        var tmp = get_pageNavigator(this.lh6_1);
        goBackOrReplaceWith(tmp, () => new (ContractorProject())(this.mh6_1.yf3_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$actionBar$discardButton$slambda$slambdaClass = $;
  }
  return ChangeOrderForm2$actionBar$discardButton$slambda$slambdaClass;
}
function ChangeOrderForm2$actionBar$discardButton$slambda$slambda_0($$this$button, this$0) {
  var i = new (ChangeOrderForm2$actionBar$discardButton$slambda$slambda())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_25($this, $this$launch, $completion) {
  var tmp = delay(500n, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.nh6_1.kem($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var ChangeOrderForm2$actionBar$deleteButton$slambda$slambda$slambdaClass;
function ChangeOrderForm2$actionBar$deleteButton$slambda$slambda$slambda() {
  if (ChangeOrderForm2$actionBar$deleteButton$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.nh6_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_25.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$actionBar$deleteButton$slambda$slambda$slambdaClass = $;
  }
  return ChangeOrderForm2$actionBar$deleteButton$slambda$slambda$slambdaClass;
}
function ChangeOrderForm2$actionBar$deleteButton$slambda$slambda$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$actionBar$deleteButton$slambda$slambda$slambda())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ChangeOrderForm2$actionBar$deleteButton$slambda$slambdaClass;
function ChangeOrderForm2$actionBar$deleteButton$slambda$slambda() {
  if (ChangeOrderForm2$actionBar$deleteButton$slambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.oh6_1 = $$this$button;
        this.ph6_1 = this$0;
      }
      uao($completion) {
        var tmp = get_AppScope();
        launch(tmp, VOID, VOID, ChangeOrderForm2$actionBar$deleteButton$slambda$slambda$slambda_0(this.ph6_1));
        var tmp_0 = get_mainPageNavigator(this.oh6_1);
        goBackOrReplaceWith(tmp_0, () => new (ContractorProject())(this.ph6_1.yf3_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$actionBar$deleteButton$slambda$slambdaClass = $;
  }
  return ChangeOrderForm2$actionBar$deleteButton$slambda$slambdaClass;
}
function ChangeOrderForm2$actionBar$deleteButton$slambda$slambda_0($$this$button, this$0) {
  var i = new (ChangeOrderForm2$actionBar$deleteButton$slambda$slambda())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_26($this, it, $completion) {
  if (it) {
    var tmp = $this.qh6_1.sh6($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = get_mainPageNavigator($this.rh6_1);
    goBackOrReplaceWith(tmp_0, () => new (ContractorProject())($this.qh6_1.yf3_1));
  }
  return Unit_instance;
}
var ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambdaClass;
function ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambda() {
  if (ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.qh6_1 = this$0;
        this.rh6_1 = $$this$button;
      }
      egk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_26.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambdaClass = $;
  }
  return ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambdaClass;
}
function ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambda_0(this$0, $$this$button) {
  var i = new (ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambda())(this$0, $$this$button);
  var l = (it, $completion) => i.egk(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_27($this, it, $completion) {
  if (it) {
    var tmp = $this.th6_1.bak($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = get_mainPageNavigator($this.uh6_1);
    goBackOrReplaceWith(tmp_0, () => new (ContractorProject())($this.th6_1.yf3_1));
  }
  return Unit_instance;
}
var ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambdaClass_0;
function ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambda_1() {
  if (ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.th6_1 = this$0;
        this.uh6_1 = $$this$button;
      }
      egk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_27.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambdaClass_0 = $;
  }
  return ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambdaClass_0;
}
function ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambda_2(this$0, $$this$button) {
  var i = new (ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambda_1())(this$0, $$this$button);
  var l = (it, $completion) => i.egk(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_notifyDeleting__mfax07($this, form, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = form.y94();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var number = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.cf4_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var outerNumber = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.lf4_1;
  var tmp_1 = await_0(this_2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = tmp_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = item.y94();
    var tmp_2 = await_0(this_3, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var itemNumber = tmp_2;
    if (compareTo(itemNumber, number) > 0) {
      var tmp_3 = item.y94().iah(outerNumber + '.' + (index_0 + 1 | 0), $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
    }
  }
  return Unit_instance;
}
function *_generator_publish__pkz857($this, $completion) {
  var tmp = $this.ih6(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var session = tmp_0;
  var tmp_1 = session.vfw().lff_1.qfh($this.zf3_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var updated = tmp_1;
  var tmp_2 = (it) => it.o57_1.equals($this.zf3_1);
  session.jfv_1.eeo(tmp_2, (it) => updated);
  return Unit_instance;
}
function *_generator_unpublish__6khfdq($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = session.vfw().lff_1.rfh($this.zf3_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function changeOptions($this, _this__u8e3s4) {
  var tmp = get_compact(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  dynamicTheme(view, ($this$dynamicTheme) => {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!$this$dynamicTheme.daj($this.kf4_1).i1()) {
      tmp = DisabledSemantic_getInstance();
    } else {
      tmp = null;
    }
    return tmp;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Checkbox())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = Checkbox$_get_enabled_$ref_57hbqa_0(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Checkbox$_set_enabled_$ref_zhvi26_0(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp$ret$1 = $this$reactiveScope.daj($this.kf4_1).i1();
    this_0.set(tmp$ret$1);
    return Unit_instance;
  });
  view_0.zah(view_0.ebk_1, $this.gf4_1);
  view.hbb(p_0, view_0);
  var tmp_2 = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  view_1.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint = get_AppDimensions().ig2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowCollapsingToColumn())(view_1.pc(), listOf(new (Dimension())(breakpoint)));
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  bodyBold(view_2, 'Group Change?');
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.lba(view_3.qb6_1.abf(BodySemantic_getInstance()));
  view_3.ccp('Select to <u>display<\/u> <strong>new<\/strong> work items as a change group. Approve items independently.');
  view_2.hbb(p_3, view_3);
  view_1.hbb(p_2, view_2);
  smallBody(view_1, '(If left unchecked, single or multiple items display independently for approval and with original items for scope work.  If checked items display like a mini-project.)');
  view.hbb(p_1, view_1);
  view.lbb(tmp_2, view_1);
  _this__u8e3s4.hbb(p, view);
  _this__u8e3s4.lbb(tmp, view);
  var tmp_3 = shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => $this$shownWhen.daj($this.gf4_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs_4 = _this__u8e3s4.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? _this__u8e3s4 : tmp0_elvis_lhs_4;
  _this__u8e3s4.gbb(p_4, view_4);
  view_4.zbm(true);
  view_4.bb9(get_AppDimensions().zg1_1);
  var tmp_4 = get_compact(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  view_5.zbm(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (Checkbox())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.gbb(p_6, view_6);
  view_6.zah(view_6.ebk_1, $this.ff4_1);
  view_5.hbb(p_6, view_6);
  var tmp_5 = get_expanding(view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (RowOrCol())(view_5.pc());
  var tmp0_elvis_lhs_7 = view_5.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
  view_5.gbb(p_7, view_7);
  view_7.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint_0 = get_AppDimensions().ig2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowCollapsingToColumn())(view_7.pc(), listOf(new (Dimension())(breakpoint_0)));
  var tmp0_elvis_lhs_8 = view_7.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.gbb(p_8, view_8);
  bodyBold(view_8, 'Link Items for Approval?');
  body(view_8, 'Select to allow for linking change items.');
  view_7.hbb(p_8, view_8);
  smallBody(view_7, '(Change work items each display within the group to be approved/rejected as a whole.)');
  view_5.hbb(p_7, view_7);
  view_5.lbb(tmp_5, view_7);
  view_4.hbb(p_5, view_5);
  view_4.lbb(tmp_4, view_5);
  var tmp_6 = get_compact(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_9 = view_4.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_4 : tmp0_elvis_lhs_9;
  view_4.gbb(p_9, view_9);
  view_9.zbm(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (Checkbox())(view_9.pc());
  var tmp0_elvis_lhs_10 = view_9.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
  view_9.gbb(p_10, view_10);
  view_10.zah(view_10.ebk_1, $this.ef4_1);
  view_9.hbb(p_10, view_10);
  var tmp_7 = get_expanding(view_9);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (RowOrCol())(view_9.pc());
  var tmp0_elvis_lhs_11 = view_9.ebb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_9 : tmp0_elvis_lhs_11;
  view_9.gbb(p_11, view_11);
  view_11.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
  var breakpoint_1 = get_AppDimensions().ig2_1;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (RowCollapsingToColumn())(view_11.pc(), listOf(new (Dimension())(breakpoint_1)));
  var tmp0_elvis_lhs_12 = view_11.ebb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
  view_11.gbb(p_12, view_12);
  bodyBold(view_12, 'Scope Approach?');
  body(view_12, 'Select to work approved items as one set of scope.');
  view_11.hbb(p_12, view_12);
  smallBody(view_11, '(Start Work, Request Signoff, and Get Paid as a group.)');
  view_9.hbb(p_11, view_11);
  view_9.lbb(tmp_7, view_11);
  view_4.hbb(p_9, view_9);
  view_4.lbb(tmp_6, view_9);
  _this__u8e3s4.hbb(p_4, view_4);
  _this__u8e3s4.lbb(tmp_3, view_4);
}
function subformControls($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_entries();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (newChangesAllowed(element)) {
      destination.v(element);
    }
  }
  var allowedStates = toSet(destination);
  var disallowedStates = setOf(LineItemState_InProgress_getInstance());
  var availableOptions = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this$remember.daj($this.kf4_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$3 = item.sh3_1;
      destination.v(tmp$ret$3);
    }
    var modified = destination;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.daj($this.vgm());
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList().w();
    var _iterator__ex2g4s_0 = tmp0.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element = _iterator__ex2g4s_0.o1();
      if (!modified.t1(element.mf9_1) && allowedStates.t1(element.mfy())) {
        destination_0.v(element);
      }
    }
    return destination_0;
  });
  var removableOptions = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.daj(availableOptions);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!disallowedStates.t1(element.mfy()) && element.jf9_1.a6l_1 === Companion_instance.m62(0)) {
        destination.v(element);
      }
    }
    return destination;
  });
  var tmp = view.kbb(subformControls$_anonymous_$expandingIfNarrow_f01g1r(view), get_tertiaryButton(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = Button$_get_enabled_$ref_61t7nx_1(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz_1(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp;
    if (!$this$reactiveScope.daj($this.gf4_1)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this$reactiveScope.daj(removableOptions).i1();
    } else {
      tmp = false;
    }
    var tmp$ret$13 = tmp;
    this_0.set(tmp$ret$13);
    return Unit_instance;
  });
  var tmp_2 = get_centered(view_0);
  view_0.lbb(tmp_2, specCenteredContent(view_0, true, ChangeOrderForm2$subformControls$lambda));
  onClick(view_0, 'Remove Work Item', VOID, ChangeOrderForm2$subformControls$slambda_0($this, removableOptions));
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  var tmp_3 = view.kbb(subformControls$_anonymous_$expandingIfNarrow_f01g1r(view), get_tertiaryButton(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Button())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  var tmp_4 = KMutableProperty0();
  var tmp_5 = Button$_get_enabled_$ref_61t7nx_2(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('enabled', 0, tmp_4, tmp_5, Button$_set_enabled_$ref_o8kynz_2(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp;
    if (!$this$reactiveScope.daj($this.gf4_1)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this$reactiveScope.daj(availableOptions).i1();
    } else {
      tmp = false;
    }
    var tmp$ret$19 = tmp;
    this_1.set(tmp$ret$19);
    return Unit_instance;
  });
  var tmp_6 = get_centered(view_1);
  view_1.lbb(tmp_6, specCenteredContent(view_1, true, ChangeOrderForm2$subformControls$lambda_0));
  onClick(view_1, 'Modify Work Item', VOID, ChangeOrderForm2$subformControls$slambda_2($this, availableOptions));
  view.hbb(p_1, view_1);
  view.lbb(tmp_3, view_1);
  var tmp_7 = view.kbb(subformControls$_anonymous_$expandingIfNarrow_f01g1r(view), get_tertiaryButton(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Button())(view.pc());
  var tmp0_elvis_lhs_2 = view.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.gbb(p_2, view_2);
  var tmp_8 = get_centered(view_2);
  view_2.lbb(tmp_8, specCenteredContent(view_2, true, ChangeOrderForm2$subformControls$lambda_1));
  onClick(view_2, 'Add New Work Item', VOID, ChangeOrderForm2$subformControls$slambda_4($this));
  view.hbb(p_2, view_2);
  view.lbb(tmp_7, view_2);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function renderWide($this, _this__u8e3s4) {
  var tmp = get_scrolling(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  var tmp_0 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  view_0.bb9(get_AppDimensions().bg2_1);
  launch(view_0, VOID, VOID, ChangeOrderForm2$renderWide$slambda_0($this, view_0));
  title(view_0, ($this$title) => {
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl_12($this$title);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_12($this$title));
    reactiveScope($this$title, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.daj($this.lfy()).b7b_1 + ' Change Order';
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    return Unit_instance;
  });
  $this.vh6(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(true);
  view_1.bb9(get_AppDimensions().zg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.zbm(false);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.lba(view_3.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
  var tmp_1 = KMutableProperty0();
  var tmp_2 = TextView$_get_content_$ref_4pzcwl_13(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_13(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var tmp$ret$2 = 'Change Order ' + $this$reactiveScope.daj($this.cf4_1);
    this_0.set(tmp$ret$2);
    return Unit_instance;
  });
  view_2.hbb(p_3, view_3);
  var tmp_3 = get_centered(view_2);
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.gbb(p_4, view_4);
  view_4.lba(view_4.qb6_1.abf(SmallBodySemantic_getInstance()));
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl_14(view_4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_14(view_4));
  reactiveScope(view_4, ($this$reactiveScope) => {
    var tmp$ret$9 = renderToString($this$reactiveScope.daj($this.bf4_1).a58_1, VOID, VOID, VOID, false);
    this_1.set(tmp$ret$9);
    return Unit_instance;
  });
  view_2.hbb(p_4, view_4);
  view_2.lbb(tmp_3, view_4);
  view_1.hbb(p_2, view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_5 = view_1.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
  view_1.gbb(p_5, view_5);
  view_5.zbm(false);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_2 = $this.bf4_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_6 = serializerOrContextual(createKType(getKClass(ChangeRequest()), arrayOf([]), false));
  var tmp$ret$20 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$20);
  var tmp$ret$22 = get_title(it);
  var tmp$ret$23 = lensPath(this_2, tmp$ret$22);
  var title_0 = assertNotBlank(tmp$ret$23);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.gbb(p_6, view_6);
  view_6.zbm(false);
  view_6.bb9(get_AppDimensions().rg2_1);
  view_6.lbb(get_centered(view_6), bodyBold(view_6, 'Change Title:'));
  view_6.lbb(colored(view_6, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_6, '*'));
  view_5.hbb(p_6, view_6);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_7 = view_5.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (TextInput())(view_5.pc());
  var tmp0_elvis_lhs_7 = view_5.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
  view_5.gbb(p_7, view_7);
  view_7.gba(get_rem(0.35));
  view_7.zah(view_7.icn_1, title_0);
  view_5.hbb(p_7, view_7);
  view_5.lbb(tmp_7, view_7);
  view_1.hbb(p_5, view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_8 = view_1.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_1 : tmp0_elvis_lhs_8;
  view_1.gbb(p_8, view_8);
  view_8.zbm(false);
  bodyBold(view_8, 'Total Net Change:');
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (TextView())(view_8.pc());
  var tmp0_elvis_lhs_9 = view_8.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
  view_8.gbb(p_9, view_9);
  view_9.lba(view_9.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_8 = KMutableProperty0();
  var tmp_9 = TextView$_get_content_$ref_4pzcwl_15(view_9);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb_15(view_9));
  reactiveScope(view_9, ($this$reactiveScope) => {
    var tmp$ret$36 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.daj($this.mf4_1).y5r_1);
    this_3.set(tmp$ret$36);
    return Unit_instance;
  });
  view_8.hbb(p_9, view_9);
  view_1.hbb(p_8, view_8);
  // Inline function 'com.crowpay.views.components.requiredField' call
  var label = 'Description';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_10 = view_1.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_1 : tmp0_elvis_lhs_10;
  view_1.gbb(p_10, view_10);
  view_10.zbm(true);
  view_10.bb9(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (RowOrCol())(view_10.pc());
  var tmp0_elvis_lhs_11 = view_10.ebb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
  view_10.gbb(p_11, view_11);
  view_11.zbm(false);
  view_11.bb9(get_AppDimensions().rg2_1);
  view_11.lbb(get_centered(view_11), bodyBold(view_11, label));
  view_11.lbb(colored(view_11, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_11, '*'));
  view_10.hbb(p_11, view_11);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_10 = view_10.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_4 = $this.bf4_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_11 = serializerOrContextual(createKType(getKClass(ChangeRequest()), arrayOf([]), false));
  var tmp$ret$52 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$52);
  var tmp$ret$54 = get_description(it_0);
  var tmp$ret$55 = lensPath(this_4, tmp$ret$54);
  var description = assertNotBlank(tmp$ret$55);
  var tmp_12 = sizeConstraints(view_10, VOID, VOID, get_rem_0(8));
  // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (TextArea())(view_10.pc());
  var tmp0_elvis_lhs_12 = view_10.ebb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_10 : tmp0_elvis_lhs_12;
  view_10.gbb(p_12, view_12);
  view_12.zah(view_12.scl_1, description);
  view_10.hbb(p_12, view_12);
  var tmp$ret$59 = view_10.lbb(tmp_12, view_12);
  view_10.lbb(tmp_10, tmp$ret$59);
  view_1.hbb(p_10, view_10);
  changeOptions($this, view_1);
  view_0.hbb(p_1, view_1);
  $this.vh6(view_0);
  view_0.lbb(get_atEnd(view_0), subformControls($this, view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_13 = view_0.ebb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_0 : tmp0_elvis_lhs_13;
  view_0.gbb(p_13, view_13);
  view_13.zbm(true);
  view_13.bb9(get_px(0));
  var tmp_13 = sizeConstraints(view_13, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(3));
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (TextView())(view_13.pc());
  var tmp0_elvis_lhs_14 = view_13.ebb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
  view_13.gbb(p_14, view_14);
  view_14.lba(view_14.qb6_1.abf(SubtitleSemantic_getInstance()));
  var tmp_14 = KMutableProperty0();
  var tmp_15 = TextView$_get_content_$ref_4pzcwl_16(view_14);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_5 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, TextView$_set_content_$ref_pketfb_16(view_14));
  reactiveScope(view_14, ($this$reactiveScope) => {
    var tmp$ret$69 = 'Change Order ' + $this$reactiveScope.daj($this.cf4_1) + ': ' + $this$reactiveScope.daj($this.bf4_1).q57_1;
    this_5.set(tmp$ret$69);
    return Unit_instance;
  });
  view_13.hbb(p_14, view_14);
  view_13.lbb(tmp_13, view_14);
  var tmp_16 = sizeConstraints(view_13, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(2));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_15 = new (RowOrCol())(view_13.pc());
  var tmp0_elvis_lhs_15 = view_13.ebb_1;
  var p_15 = tmp0_elvis_lhs_15 == null ? view_13 : tmp0_elvis_lhs_15;
  view_13.gbb(p_15, view_15);
  view_15.zbm(false);
  view_15.bb9(get_px(0));
  var tmp_17 = weight(view_15, 4.0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_16 = new (TextView())(view_15.pc());
  var tmp0_elvis_lhs_16 = view_15.ebb_1;
  var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
  view_15.gbb(p_16, view_16);
  view_16.lba(view_16.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_18 = KMutableProperty0();
  var tmp_19 = TextView$_get_visible_$ref_cygc3o(view_16);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_6 = getPropertyCallableRef('visible', 0, tmp_18, tmp_19, TextView$_set_visible_$ref_rs9jjk(view_16));
  reactiveScope(view_16, ($this$reactiveScope) => {
    var tmp$ret$76 = !$this$reactiveScope.daj($this.gf4_1);
    this_6.set(tmp$ret$76);
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'Work Item';
  var tmp_20 = view_16.vb5_1;
  var tmp_21;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_21 = '\xA0';
  } else {
    tmp_21 = value;
  }
  tmp_20.hbu(tmp_21);
  view_15.hbb(p_16, view_16);
  view_15.lbb(tmp_17, view_16);
  var tmp_22 = weight(view_15, 1.0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_17 = new (TextView())(view_15.pc());
  var tmp0_elvis_lhs_17 = view_15.ebb_1;
  var p_17 = tmp0_elvis_lhs_17 == null ? view_15 : tmp0_elvis_lhs_17;
  view_15.gbb(p_17, view_17);
  view_17.lba(view_17.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_23 = KMutableProperty0();
  var tmp_24 = TextView$_get_visible_$ref_cygc3o_0(view_17);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_7 = getPropertyCallableRef('visible', 0, tmp_23, tmp_24, TextView$_set_visible_$ref_rs9jjk_0(view_17));
  reactiveScope(view_17, ($this$reactiveScope) => {
    var tmp$ret$85 = $this$reactiveScope.daj($this.ff4_1);
    this_7.set(tmp$ret$85);
    return Unit_instance;
  });
  view_17.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_25 = view_17.vb5_1;
  var tmp_26;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Linked?') === 0) {
    tmp_26 = '\xA0';
  } else {
    tmp_26 = 'Linked?';
  }
  tmp_25.hbu(tmp_26);
  view_15.hbb(p_17, view_17);
  view_15.lbb(tmp_22, view_17);
  var tmp_27 = weight(view_15, 1.0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_18 = new (TextView())(view_15.pc());
  var tmp0_elvis_lhs_18 = view_15.ebb_1;
  var p_18 = tmp0_elvis_lhs_18 == null ? view_15 : tmp0_elvis_lhs_18;
  view_15.gbb(p_18, view_18);
  view_18.lba(view_18.qb6_1.abf(BodySemantic_getInstance()));
  view_18.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_28 = view_18.vb5_1;
  var tmp_29;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('ID') === 0) {
    tmp_29 = '\xA0';
  } else {
    tmp_29 = 'ID';
  }
  tmp_28.hbu(tmp_29);
  view_15.hbb(p_18, view_18);
  view_15.lbb(tmp_27, view_18);
  var tmp_30 = weight(view_15, 1.0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_19 = new (TextView())(view_15.pc());
  var tmp0_elvis_lhs_19 = view_15.ebb_1;
  var p_19 = tmp0_elvis_lhs_19 == null ? view_15 : tmp0_elvis_lhs_19;
  view_15.gbb(p_19, view_19);
  view_19.lba(view_19.qb6_1.abf(BodySemantic_getInstance()));
  view_19.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_0 = 'Original';
  var tmp_31 = view_19.vb5_1;
  var tmp_32;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_0) === 0) {
    tmp_32 = '\xA0';
  } else {
    tmp_32 = value_0;
  }
  tmp_31.hbu(tmp_32);
  view_15.hbb(p_19, view_19);
  view_15.lbb(tmp_30, view_19);
  var tmp_33 = weight(view_15, 1.0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_20 = new (TextView())(view_15.pc());
  var tmp0_elvis_lhs_20 = view_15.ebb_1;
  var p_20 = tmp0_elvis_lhs_20 == null ? view_15 : tmp0_elvis_lhs_20;
  view_15.gbb(p_20, view_20);
  view_20.lba(view_20.qb6_1.abf(BodySemantic_getInstance()));
  view_20.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_1 = 'Remaining';
  var tmp_34 = view_20.vb5_1;
  var tmp_35;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_1) === 0) {
    tmp_35 = '\xA0';
  } else {
    tmp_35 = value_1;
  }
  tmp_34.hbu(tmp_35);
  view_15.hbb(p_20, view_20);
  view_15.lbb(tmp_33, view_20);
  var tmp_36 = weight(view_15, 1.0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_21 = new (TextView())(view_15.pc());
  var tmp0_elvis_lhs_21 = view_15.ebb_1;
  var p_21 = tmp0_elvis_lhs_21 == null ? view_15 : tmp0_elvis_lhs_21;
  view_15.gbb(p_21, view_21);
  view_21.lba(view_21.qb6_1.abf(BodySemantic_getInstance()));
  view_21.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_37 = view_21.vb5_1;
  var tmp_38;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Change') === 0) {
    tmp_38 = '\xA0';
  } else {
    tmp_38 = 'Change';
  }
  tmp_37.hbu(tmp_38);
  view_15.hbb(p_21, view_21);
  view_15.lbb(tmp_36, view_21);
  var tmp_39 = weight(view_15, 1.0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_22 = new (TextView())(view_15.pc());
  var tmp0_elvis_lhs_22 = view_15.ebb_1;
  var p_22 = tmp0_elvis_lhs_22 == null ? view_15 : tmp0_elvis_lhs_22;
  view_15.gbb(p_22, view_22);
  view_22.lba(view_22.qb6_1.abf(BodySemantic_getInstance()));
  view_22.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_2 = 'Scope Total';
  var tmp_40 = view_22.vb5_1;
  var tmp_41;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_2) === 0) {
    tmp_41 = '\xA0';
  } else {
    tmp_41 = value_2;
  }
  tmp_40.hbu(tmp_41);
  view_15.hbb(p_22, view_22);
  view_15.lbb(tmp_39, view_22);
  view_13.hbb(p_15, view_15);
  view_13.lbb(tmp_16, view_15);
  greySeparator(view_13);
  var tmp_42 = shownWhen(view_13, VOID, ($this$shownWhen) => $this$shownWhen.daj($this.gf4_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_23 = new (RowOrCol())(view_13.pc());
  var tmp0_elvis_lhs_23 = view_13.ebb_1;
  var p_23 = tmp0_elvis_lhs_23 == null ? view_13 : tmp0_elvis_lhs_23;
  view_13.gbb(p_23, view_23);
  view_23.zbm(true);
  view_23.bb9(get_px(0));
  var tmp_43 = sizeConstraints(view_23, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(3));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_24 = new (RowOrCol())(view_23.pc());
  var tmp0_elvis_lhs_24 = view_23.ebb_1;
  var p_24 = tmp0_elvis_lhs_24 == null ? view_23 : tmp0_elvis_lhs_24;
  view_23.gbb(p_24, view_24);
  view_24.zbm(false);
  view_24.bb9(get_px(0));
  view_24.lbb(view_24.kbb(weight(view_24, 4.0), get_centered(view_24)), bodyBold(view_24, 'Group Summary'));
  var tmp_44 = weight(view_24, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_25 = new (Frame())(view_24.pc());
  var tmp0_elvis_lhs_25 = view_24.ebb_1;
  var p_25 = tmp0_elvis_lhs_25 == null ? view_24 : tmp0_elvis_lhs_25;
  view_24.gbb(p_25, view_25);
  var tmp_45 = view_25.kbb(colored(view_25, AppColors_getInstance().ffz_1.zg9_1), get_centered(view_25));
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_26 = new (IconView())(view_25.pc());
  var tmp0_elvis_lhs_26 = view_25.ebb_1;
  var p_26 = tmp0_elvis_lhs_26 == null ? view_25 : tmp0_elvis_lhs_26;
  view_25.gbb(p_26, view_26);
  var tmp_46 = KMutableProperty0();
  var tmp_47 = IconView$_get_shown_$ref_js8irt(view_26);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_8 = getPropertyCallableRef('shown', 0, tmp_46, tmp_47, IconView$_set_shown_$ref_9ilxmr(view_26));
  reactiveScope(view_26, ($this$reactiveScope) => {
    var tmp$ret$133 = $this$reactiveScope.daj($this.nf4_1);
    this_8.set(tmp$ret$133);
    return Unit_instance;
  });
  view_26.sbt(get_linked(Companion_getInstance_0()));
  view_25.hbb(p_26, view_26);
  view_25.lbb(tmp_45, view_26);
  view_24.hbb(p_25, view_25);
  view_24.lbb(tmp_44, view_25);
  var tmp_48 = view_24.kbb(weight(view_24, 1.0), get_centered(view_24));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_27 = new (TextView())(view_24.pc());
  var tmp0_elvis_lhs_27 = view_24.ebb_1;
  var p_27 = tmp0_elvis_lhs_27 == null ? view_24 : tmp0_elvis_lhs_27;
  view_24.gbb(p_27, view_27);
  view_27.lba(view_27.qb6_1.abf(BodySemantic_getInstance()));
  view_27.dbs(Align_Center_getInstance());
  var tmp_49 = KMutableProperty0();
  var tmp_50 = TextView$_get_content_$ref_4pzcwl_17(view_27);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_9 = getPropertyCallableRef('content', 0, tmp_49, tmp_50, TextView$_set_content_$ref_pketfb_17(view_27));
  reactiveScope(view_27, ($this$reactiveScope) => {
    var tmp$ret$141 = $this$reactiveScope.daj($this.cf4_1);
    this_9.set(tmp$ret$141);
    return Unit_instance;
  });
  view_24.hbb(p_27, view_27);
  view_24.lbb(tmp_48, view_27);
  var tmp_51 = view_24.kbb(weight(view_24, 1.0), get_centered(view_24));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_28 = new (TextView())(view_24.pc());
  var tmp0_elvis_lhs_28 = view_24.ebb_1;
  var p_28 = tmp0_elvis_lhs_28 == null ? view_24 : tmp0_elvis_lhs_28;
  view_24.gbb(p_28, view_28);
  view_28.lba(view_28.qb6_1.abf(BodySemantic_getInstance()));
  view_28.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_52 = view_28.vb5_1;
  var tmp_53;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('$0.00') === 0) {
    tmp_53 = '\xA0';
  } else {
    tmp_53 = '$0.00';
  }
  tmp_52.hbu(tmp_53);
  view_24.hbb(p_28, view_28);
  view_24.lbb(tmp_51, view_28);
  var tmp_54 = view_24.kbb(weight(view_24, 1.0), get_centered(view_24));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_29 = new (TextView())(view_24.pc());
  var tmp0_elvis_lhs_29 = view_24.ebb_1;
  var p_29 = tmp0_elvis_lhs_29 == null ? view_24 : tmp0_elvis_lhs_29;
  view_24.gbb(p_29, view_29);
  view_29.lba(view_29.qb6_1.abf(BodySemantic_getInstance()));
  view_29.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_55 = view_29.vb5_1;
  var tmp_56;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('$0.00') === 0) {
    tmp_56 = '\xA0';
  } else {
    tmp_56 = '$0.00';
  }
  tmp_55.hbu(tmp_56);
  view_24.hbb(p_29, view_29);
  view_24.lbb(tmp_54, view_29);
  var total = share($this.jf4_1, ChangeOrderForm2$renderWide$lambda);
  var tmp_57 = weight(view_24, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_30 = new (Frame())(view_24.pc());
  var tmp0_elvis_lhs_30 = view_24.ebb_1;
  var p_30 = tmp0_elvis_lhs_30 == null ? view_24 : tmp0_elvis_lhs_30;
  view_24.gbb(p_30, view_30);
  var tmp_58 = get_centered(view_30);
  view_30.lbb(tmp_58, renderPriceChange(view_30, VOID, ($this$renderPriceChange) => $this$renderPriceChange.daj(total)));
  view_24.hbb(p_30, view_30);
  view_24.lbb(tmp_57, view_30);
  var tmp_59 = view_24.kbb(weight(view_24, 1.0), get_centered(view_24));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_31 = new (TextView())(view_24.pc());
  var tmp0_elvis_lhs_31 = view_24.ebb_1;
  var p_31 = tmp0_elvis_lhs_31 == null ? view_24 : tmp0_elvis_lhs_31;
  view_24.gbb(p_31, view_31);
  view_31.lba(view_31.qb6_1.abf(BodySemantic_getInstance()));
  view_31.dbs(Align_Center_getInstance());
  var tmp_60 = KMutableProperty0();
  var tmp_61 = TextView$_get_content_$ref_4pzcwl_18(view_31);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_10 = getPropertyCallableRef('content', 0, tmp_60, tmp_61, TextView$_set_content_$ref_pketfb_18(view_31));
  reactiveScope(view_31, ($this$reactiveScope) => {
    var tmp$ret$165 = MonetaryValue__toString_impl_xslc77($this$reactiveScope.daj(total).y5r_1);
    this_10.set(tmp$ret$165);
    return Unit_instance;
  });
  view_24.hbb(p_31, view_31);
  view_24.lbb(tmp_59, view_31);
  view_23.hbb(p_24, view_24);
  view_23.lbb(tmp_43, view_24);
  greySeparator(view_23);
  view_13.hbb(p_23, view_23);
  view_13.lbb(tmp_42, view_23);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_32 = new (RowOrCol())(view_13.pc());
  var tmp0_elvis_lhs_32 = view_13.ebb_1;
  var p_32 = tmp0_elvis_lhs_32 == null ? view_13 : tmp0_elvis_lhs_32;
  view_13.gbb(p_32, view_32);
  view_32.zbm(true);
  view_32.bb9(get_px(0));
  forEach(view_32, $this.lf4_1, ChangeOrderForm2$renderWide$lambda_0);
  view_13.hbb(p_32, view_32);
  view_0.hbb(p_13, view_13);
  space(view_0, get_AppDimensions().yg1_1);
  view.hbb(p_0, view_0);
  view.lbb(tmp_0, view_0);
  launch(view, VOID, VOID, ChangeOrderForm2$renderWide$slambda_2($this));
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
var FormSectionClass;
function FormSection() {
  if (FormSectionClass === VOID) {
    class $ extends Enum() {
      static oh3(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.nh3_1 = displayName;
        return $this;
      }
      e90() {
        return this.nh3_1;
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'FormSection', VOID, VOID, [HasDisplayName(), Enum()]);
    FormSectionClass = $;
  }
  return FormSectionClass;
}
function renderNarrow($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  var tmp = view.kbb(get_expanding(view), get_scrolling(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  view_0.bb9(get_AppDimensions().bg2_1);
  title(view_0, ($this$title) => {
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl_19($this$title);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_19($this$title));
    reactiveScope($this$title, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.daj($this.lfy()).b7b_1 + ' Change Order ' + $this$reactiveScope.daj($this.cf4_1);
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    return Unit_instance;
  });
  var tmp_0 = view_0.jbb(InnerTabBar_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  var _iterator__ex2g4s = get_entries_0().m1();
  while (_iterator__ex2g4s.n1()) {
    var section = _iterator__ex2g4s.o1();
    var tmp_1 = get_expanding(view_1);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var tmp$ret$2 = view_1.jbb(ButtonSemantic_getInstance());
    var tmp_2 = view_1.kbb(tmp_1, tmp$ret$2);
    // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RadioToggleButton())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.gbb(p_2, view_2);
    view_2.lbb(get_centered(view_2), body(view_2, section.nh3_1));
    view_2.zah(view_2.bc9_1, equalTo($this.of4_1, section));
    view_1.hbb(p_2, view_2);
    view_1.lbb(tmp_2, view_2);
  }
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_0, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Frame())(view_0.pc());
  var tmp0_elvis_lhs_3 = view_0.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
  view_0.gbb(p_3, view_3);
  var $this$frame = view_3;
  reactive($this$frame, ($this$reactive) => {
    $this$frame.bba();
    var tmp;
    switch ($this$reactive.daj($this.of4_1).b4_1) {
      case 0:
        tmp = settingsSection($this, $this$frame);
        break;
      case 1:
        tmp = itemsSection($this, $this$frame);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  });
  view_0.hbb(p_3, view_3);
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  $this.vh6(view);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function settingsSection($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  // Inline function 'com.crowpay.views.components.requiredField' call
  var label = 'Change Title';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  view_0.bb9(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.bb9(get_AppDimensions().rg2_1);
  view_1.lbb(get_centered(view_1), bodyBold(view_1, label));
  view_1.lbb(colored(view_1, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_1, '*'));
  view_0.hbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = view_0.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextInput())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.gbb(p_2, view_2);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_0 = $this.bf4_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(ChangeRequest()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$5);
  var tmp$ret$7 = get_title(it);
  var tmp$ret$8 = lensPath(this_0, tmp$ret$7);
  view_2.zah(view_2.icn_1, assertNotBlank(tmp$ret$8));
  view_0.hbb(p_2, view_2);
  view_0.lbb(tmp, view_2);
  view.hbb(p_0, view_0);
  // Inline function 'com.crowpay.views.components.requiredField' call
  var label_0 = 'Description';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  view_3.zbm(true);
  view_3.bb9(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.gbb(p_4, view_4);
  view_4.zbm(false);
  view_4.bb9(get_AppDimensions().rg2_1);
  view_4.lbb(get_centered(view_4), bodyBold(view_4, label_0));
  view_4.lbb(colored(view_4, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_4, '*'));
  view_3.hbb(p_4, view_4);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_1 = view_3.jbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextArea())(view_3.pc());
  var tmp0_elvis_lhs_5 = view_3.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
  view_3.gbb(p_5, view_5);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  var this_1 = $this.bf4_1;
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(ChangeRequest()), arrayOf([]), false));
  var tmp$ret$23 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$23);
  var tmp$ret$25 = get_description(it_0);
  var tmp$ret$26 = lensPath(this_1, tmp$ret$25);
  view_5.zah(view_5.scl_1, assertNotBlank(tmp$ret$26));
  view_3.hbb(p_5, view_5);
  view_3.lbb(tmp_1, view_5);
  view.hbb(p_3, view_3);
  // Inline function 'com.crowpay.views.components.keyView' call
  var key = 'Total Net Change';
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_6 = view.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.gbb(p_6, view_6);
  view_6.zbm(false);
  view_6.bb9(get_rem(0.5));
  bodyBold(view_6, key + ':');
  var tmp_3 = get_expanding(view_6);
  var tmp$ret$36 = renderPriceChange(view_6, false, ($this$renderPriceChange) => $this$renderPriceChange.daj($this.mf4_1));
  view_6.lbb(tmp_3, tmp$ret$36);
  view.hbb(p_6, view_6);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Space())(view.pc());
  var tmp0_elvis_lhs_7 = view.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
  view.gbb(p_7, view_7);
  view.hbb(p_7, view_7);
  changeOptions($this, view);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function itemsSection($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  subformControls($this, view);
  var tmp = view.jbb(ListSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  forEach(view_0, $this.lf4_1, ChangeOrderForm2$itemsSection$lambda);
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function *_generator_itemChangeForm__413zbz($this, itemChange, jumpOnNew, $completion) {
  var tmp0_safe_receiver = $this.pf4_1.p3(itemChange.a72_1);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.apply' call
    // Inline function 'com.crowpay.utils.updatePublished' call
    var this_0 = tmp0_safe_receiver.th3_1;
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(PendingItemChange()), arrayOf([]), false));
    var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var tmp_1 = updatePublished(this_0, itemChange, tmp$ret$0, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp0_safe_receiver;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_1 = new (ChangeLineItemForm())($this, itemChange);
    var tmp0 = $this.pf4_1;
    // Inline function 'kotlin.collections.set' call
    var key = itemChange.a72_1;
    tmp0.s3(key, this_1);
    if (jumpOnNew) {
      this_1.ph3_1.rg4();
    }
    tmp_2 = this_1;
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  return tmp_2;
}
function *_generator_newItemForm__zi8f8j($this, lineItem, jumpOnNew, $completion) {
  var tmp0_safe_receiver = $this.qf4_1.p3(lineItem.t75_1);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.apply' call
    // Inline function 'com.crowpay.utils.updatePublished' call
    var this_0 = tmp0_safe_receiver.mh4_1;
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(PendingLineItem()), arrayOf([]), false));
    var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var tmp_1 = updatePublished(this_0, lineItem, tmp$ret$0, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp0_safe_receiver;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_1 = new (NewLineItemForm())($this, lineItem);
    println('Created new form');
    var tmp0 = $this.qf4_1;
    // Inline function 'kotlin.collections.set' call
    var key = lineItem.t75_1;
    tmp0.s3(key, this_1);
    if (jumpOnNew) {
      this_1.ph4_1.rg4();
    }
    tmp_2 = this_1;
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  return tmp_2;
}
var ChangeLineItemFormClass;
function ChangeLineItemForm() {
  if (ChangeLineItemFormClass === VOID) {
    class $ {
      constructor($outer, start) {
        this.ch4_1 = $outer;
        this.ph3_1 = new (TargetHandler())('Change ' + start.m72_1);
        this.qh3_1 = start.g72_1;
        this.rh3_1 = start.a72_1;
        this.sh3_1 = start.d72_1;
        this.th3_1 = validated(Draft(start), this.ch4_1.af4_1);
        var tmp = this;
        var tmp_0 = this.ch4_1.vgm();
        tmp.uh3_1 = lens(tmp_0, (it) => {
          // Inline function 'kotlin.collections.find' call
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = it.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.mf9_1.equals(this.sh3_1)) {
                tmp$ret$1 = element;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw NotFound().pfx(getKClass(LineItem()), null);
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        });
        var tmp_1 = this;
        tmp_1.vh3_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if (this.qh3_1) {
            tmp = MonetaryValue__unaryMinus_impl_x5smq0($this$remember.daj(this.uh3_1).x91());
          } else {
            var tmp0_elvis_lhs = $this$remember.daj(this.th3_1).f72_1;
            var tmp_0;
            var tmp_1 = tmp0_elvis_lhs;
            if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
              tmp_0 = Companion_instance.r91(0n);
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp = tmp_0;
          }
          return new (MonetaryValue())(tmp);
        });
        var tmp_2 = this;
        var tmp_3 = this.th3_1.aak();
        var tmp_4 = lens(tmp_3, ChangeOrderForm2$ChangeLineItemForm$itemNumber$lambda);
        tmp_2.wh3_1 = withWrite(tmp_4, ChangeOrderForm2$ChangeLineItemForm$itemNumber$slambda_0(this));
        var tmp_5 = this;
        tmp_5.xh3_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$mutableRemember.daj(get_issues(this.th3_1)).i1();
        });
        var tmp_6 = this;
        tmp_6.yh3_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var d = $this$remember.daj(this.th3_1);
          var tmp;
          var tmp_0;
          if (!this.qh3_1) {
            // Inline function 'kotlin.text.isNullOrBlank' call
            var this_0 = d.e72_1;
            tmp_0 = this_0 == null || isBlank(this_0);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            var tmp0_elvis_lhs = d.f72_1;
            var tmp_1;
            var tmp_2 = tmp0_elvis_lhs;
            if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
              tmp_1 = Companion_instance.r91(0n);
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            tmp = tmp_1 === Companion_instance.r91(0n);
          } else {
            tmp = false;
          }
          return tmp;
        });
        var tmp_7 = this;
        tmp_7.zh3_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.wh3_1) + ': ' + $this$remember.daj(this.uh3_1).nf9_1);
        var tmp_8 = this;
        tmp_8.ah4_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.ch4_1.if4_1) && $this$remember.daj(this.yh3_1));
        this.bh4_1 = new (TargetHandler_0())('Change ' + start.m72_1);
      }
      wh6() {
        return this.vh3_1;
      }
      b95() {
        return this.qh3_1 ? ChangeType_Remove_getInstance() : ChangeType_Modify_getInstance();
      }
      y94() {
        return this.wh3_1;
      }
      xh6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.bb9(get_px(0));
        var tmp = get_unpadded(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Button())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        header(this, view_0);
        view_0.obg(expandAction(this.xh3_1));
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        var tmp_0 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.xh3_1));
        // Inline function 'com.crowpay.views.components.sectionIndentCol' call
        // Inline function 'com.crowpay.views.components.indentedCol' call
        var indent = Indent_Section_getInstance();
        var tmp2 = indent.agr_1;
        // Inline function 'com.crowpay.views.components.indentedCol' call
        var afterSpace = indent.bgr_1;
        var tmp_1 = get_unpadded(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        var tmp_2;
        var tmp_3 = null;
        if (!((tmp_3 == null ? null : new (Dimension())(tmp_3)) == null)) {
          tmp_2 = sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, null);
        } else {
          tmp_2 = Companion_getInstance_1();
        }
        var tmp_4 = view_1.kbb(tmp_2, indented(view_1, tmp2, afterSpace));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(true);
        view_2.bb9(get_AppDimensions().zg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Space())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_2.hbb(p_3, view_3);
        if (!this.qh3_1) {
          inputFields(this, view_2);
        }
        view_2.lbb(get_section(view_2), actionBar(this, view_2));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Space())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.gbb(p_4, view_4);
        view_2.hbb(p_4, view_4);
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp_4, view_2);
        view.hbb(p_1, view_1);
        var tmp$ret$18 = view.lbb(tmp_1, view_1);
        view.lbb(tmp_0, tmp$ret$18);
        greySeparator(view);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      yh6(_this__u8e3s4) {
        var tmp = get_lightSection(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        view_0.bb9(get_AppDimensions().bg2_1);
        leftExpandButton(view_0, this.xh3_1, false, VOID, VOID, VOID, ($this$leftExpandButton) => {
          var tmp = get_expanding($this$leftExpandButton);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$leftExpandButton.pc());
          var tmp0_elvis_lhs = $this$leftExpandButton.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$leftExpandButton : tmp0_elvis_lhs;
          $this$leftExpandButton.gbb(p, view);
          view.zbm(false);
          view.bb9(get_AppDimensions().pg2_1);
          var tmp_0 = get_centered(view);
          // Inline function 'com.crowpay.views.theming.bodyBold' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (TextView())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
          var tmp_1 = KMutableProperty0();
          var tmp_2 = TextView$_get_content_$ref_4pzcwl_5(view_0);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_5(view_0));
          reactiveScope(view_0, ($this$reactiveScope) => {
            var tmp$ret$0 = $this$reactiveScope.daj(this.uh3_1).nf9_1;
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          view.hbb(p_0, view_0);
          view.lbb(tmp_0, view_0);
          view.lbb(view.kbb(get_expanding(view), get_centered(view)), smallBody(view, this.b95().g95_1));
          view.lbb(view.kbb(view.kbb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.ah4_1)), get_centered(view)), colored(view, AppColors_getInstance().jfz_1.zg9_1)), smallBody(view, 'Needs a change'));
          var tmp_3 = get_centered(view);
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (TextView())(view.pc());
          var tmp0_elvis_lhs_1 = view.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.gbb(p_1, view_1);
          view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
          var tmp_4 = KMutableProperty0();
          var tmp_5 = TextView$_get_content_$ref_4pzcwl_6(view_1);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_6(view_1));
          reactiveScope(view_1, ($this$reactiveScope) => {
            var tmp$ret$7 = $this$reactiveScope.daj(this.wh3_1);
            this_1.set(tmp$ret$7);
            return Unit_instance;
          });
          view.hbb(p_1, view_1);
          view.lbb(tmp_3, view_1);
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp_6 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
          this.ph3_1.og4(view, tmp_6, () => {
            set_value(this.xh3_1, true);
            this.bh4_1.og5();
            return Unit_instance;
          });
          $this$leftExpandButton.hbb(p, view);
          $this$leftExpandButton.lbb(tmp, view);
          return Unit_instance;
        });
        var tmp_0 = shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.xh3_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        view_1.bb9(get_AppDimensions().bg2_1);
        if (!this.qh3_1) {
          inputFields(this, view_1);
        }
        actionBar(this, view_1);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_0, view_1);
        view.hbb(p_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
      l6() {
        this.ch4_1.pf4_1.t3(this.rh3_1);
        this.th3_1.xat().sat();
      }
      kem($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt.bind(VOID, this), $completion);
      }
      gh4($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_save__qhzefp.bind(VOID, this), $completion);
      }
    }
    initMetadataForClass($, 'ChangeLineItemForm', VOID, VOID, VOID, [0]);
    ChangeLineItemFormClass = $;
  }
  return ChangeLineItemFormClass;
}
var NewLineItemFormClass;
function NewLineItemForm() {
  if (NewLineItemFormClass === VOID) {
    class $ {
      constructor($outer, start) {
        this.uh4_1 = $outer;
        this.lh4_1 = start.t75_1;
        var tmp = this;
        tmp.mh4_1 = validated(Draft_0(($this$Draft) => start.k76(VOID, VOID, VOID, VOID, VOID, VOID, VOID, $this$Draft.daj(this.uh4_1.ff4_1))), this.uh4_1.af4_1);
        this.nh4_1 = Signal().hak(toFileData(start.z75_1));
        var tmp_0 = this;
        var tmp_1 = ChangeOrderForm2$NewLineItemForm$form$lambda;
        tmp_0.oh4_1 = new (LineItemForm())(this.mh4_1, this.nh4_1, tmp_1, lens(this.uh4_1.df4_1, ChangeOrderForm2$NewLineItemForm$form$lambda_0));
        this.ph4_1 = new (TargetHandler())('Change ' + start.g76_1);
        var tmp_2 = this;
        tmp_2.qh4_1 = remember(VOID, VOID, VOID, ($this$remember) => new (MonetaryValue())($this$remember.daj(this.mh4_1).y75_1));
        var tmp_3 = this;
        var tmp_4 = this.mh4_1.aak();
        var tmp_5 = lens(tmp_4, ChangeOrderForm2$NewLineItemForm$itemNumber$lambda);
        tmp_3.rh4_1 = withWrite(tmp_5, ChangeOrderForm2$NewLineItemForm$itemNumber$slambda_0(this));
        var tmp_6 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_0 = this.mh4_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_7 = serializerOrContextual(createKType(getKClass(PendingLineItem()), arrayOf([]), false));
        var tmp$ret$0 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$0);
        var tmp$ret$2 = get_linked_0(it);
        tmp_6.sh4_1 = lensPath(this_0, tmp$ret$2);
        var tmp_8 = this;
        tmp_8.th4_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$mutableRemember.gaj(get_issues(this.mh4_1)).i1();
        });
      }
      wh6() {
        return this.qh4_1;
      }
      y94() {
        return this.rh4_1;
      }
      xh6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.bb9(get_px(0));
        header_0(this, view);
        var tmp = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.th4_1));
        // Inline function 'com.crowpay.views.components.sectionIndentCol' call
        // Inline function 'com.crowpay.views.components.indentedCol' call
        var indent = Indent_Section_getInstance();
        var tmp2 = indent.agr_1;
        // Inline function 'com.crowpay.views.components.indentedCol' call
        var afterSpace = indent.bgr_1;
        var tmp_0 = get_unpadded(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        var tmp_1;
        var tmp_2 = null;
        if (!((tmp_2 == null ? null : new (Dimension())(tmp_2)) == null)) {
          tmp_1 = sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, null);
        } else {
          tmp_1 = Companion_getInstance_1();
        }
        var tmp_3 = view_0.kbb(tmp_1, indented(view_0, tmp2, afterSpace));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Space())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_1.hbb(p_2, view_2);
        changeForm(this, view_1);
        view_1.lbb(get_section(view_1), actionBar_0(this, view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Space())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.gbb(p_3, view_3);
        view_1.hbb(p_3, view_3);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_3, view_1);
        view.hbb(p_0, view_0);
        var tmp$ret$15 = view.lbb(tmp_0, view_0);
        view.lbb(tmp, tmp$ret$15);
        greySeparator(view);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      yh6(_this__u8e3s4) {
        var tmp = get_lightSection(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        view_0.bb9(get_AppDimensions().bg2_1);
        leftExpandButton(view_0, this.th4_1, false, VOID, VOID, VOID, ($this$leftExpandButton) => {
          var tmp = get_expanding($this$leftExpandButton);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$leftExpandButton.pc());
          var tmp0_elvis_lhs = $this$leftExpandButton.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$leftExpandButton : tmp0_elvis_lhs;
          $this$leftExpandButton.gbb(p, view);
          view.zbm(false);
          view.bb9(get_AppDimensions().pg2_1);
          view.lbb(view.kbb(view.kbb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.sh4_1)), get_centered(view)), colored(view, AppColors_getInstance().ffz_1.zg9_1)), icon(view, get_linked(Companion_getInstance_0()), 'linked'));
          var tmp_0 = get_centered(view);
          // Inline function 'com.crowpay.views.theming.bodyBold' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (TextView())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
          var tmp_1 = KMutableProperty0();
          var tmp_2 = TextView$_get_content_$ref_4pzcwl_10(view_0);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_10(view_0));
          reactiveScope(view_0, ($this$reactiveScope) => {
            // Inline function 'kotlin.text.ifBlank' call
            var this_1 = $this$reactiveScope.daj(this.mh4_1).w75_1;
            var tmp;
            if (isBlank(this_1)) {
              tmp = 'New Item';
            } else {
              tmp = this_1;
            }
            var tmp$ret$2 = tmp;
            this_0.set(tmp$ret$2);
            return Unit_instance;
          });
          view.hbb(p_0, view_0);
          view.lbb(tmp_0, view_0);
          view.lbb(view.kbb(get_expanding(view), get_centered(view)), smallBody(view, ChangeType_New_getInstance().g95_1));
          var tmp_3 = get_centered(view);
          // Inline function 'com.crowpay.views.theming.body' call
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (TextView())(view.pc());
          var tmp0_elvis_lhs_1 = view.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.gbb(p_1, view_1);
          view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
          var tmp_4 = KMutableProperty0();
          var tmp_5 = TextView$_get_content_$ref_4pzcwl_11(view_1);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_11(view_1));
          reactiveScope(view_1, ($this$reactiveScope) => {
            var tmp$ret$9 = $this$reactiveScope.daj(this.rh4_1);
            this_1.set(tmp$ret$9);
            return Unit_instance;
          });
          view.hbb(p_1, view_1);
          view.lbb(tmp_3, view_1);
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp_6 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
          this.ph4_1.og4(view, tmp_6, () => {
            set_value(this.th4_1, true);
            this.oh4_1.sg8_1.og5();
            return Unit_instance;
          });
          $this$leftExpandButton.hbb(p, view);
          $this$leftExpandButton.lbb(tmp, view);
          return Unit_instance;
        });
        var tmp_0 = shownWhen(view_0, false, ($this$shownWhen) => $this$shownWhen.daj(this.th4_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        view_1.bb9(get_AppDimensions().bg2_1);
        changeForm(this, view_1);
        actionBar_0(this, view_1);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_0, view_1);
        view.hbb(p_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
      l6() {
        this.uh4_1.qf4_1.t3(this.lh4_1);
        this.mh4_1.xat().sat();
      }
      kem($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_0.bind(VOID, this), $completion);
      }
      gh4($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_save__qhzefp_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForClass($, 'NewLineItemForm', VOID, VOID, VOID, [0]);
    NewLineItemFormClass = $;
  }
  return NewLineItemFormClass;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.zh6_1 = function_0;
      }
      wi(a, b) {
        return this.zh6_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.zh6_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function actionBar$saveButton(_this__u8e3s4, this$0) {
  var tmp = get_primaryButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  specCenteredText(view, 'Save');
  onClick(view, 'Save', VOID, ChangeOrderForm2$actionBar$saveButton$slambda_0(this$0));
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function actionBar$saveAndCloseButton(_this__u8e3s4, this$0) {
  var tmp = get_secondaryButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  specCenteredText(view, 'Save & Close');
  onClick(view, 'Save & Close', VOID, ChangeOrderForm2$actionBar$saveAndCloseButton$slambda_0(this$0, view));
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function actionBar$discardButton(_this__u8e3s4, this$0) {
  var tmp = get_textButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.lbb(get_centered(view), body(view, 'Discard'));
  onClick(view, 'Discard', VOID, ChangeOrderForm2$actionBar$discardButton$slambda_0(view, this$0));
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function actionBar$deleteButton(_this__u8e3s4, this$0) {
  var tmp = get_deleteButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  shownDefaultFalse(view, ($this$shownDefaultFalse) => $this$shownDefaultFalse.daj(this$0.bf4_1).t57_1 == null);
  view.lbb(get_centered(view), icon(view, resize(get_trash(Companion_getInstance_0()), get_rem_0(1)), 'Delete Change Order Draft'));
  onClick(view, VOID, VOID, ChangeOrderForm2$actionBar$deleteButton$slambda_0(view, this$0));
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function actionBar$publishButton(_this__u8e3s4, this$0) {
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  var $this$button = view;
  var tmp = KMutableProperty0();
  var tmp_0 = Button$_get_enabled_$ref_61t7nx_3($this$button);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp, tmp_0, Button$_set_enabled_$ref_o8kynz_3($this$button));
  reactiveScope($this$button, ($this$reactiveScope) => {
    var tmp;
    if ($this$reactiveScope.daj(this$0.df4_1)) {
      tmp = true;
    } else {
      var tmp_0;
      if ($this$reactiveScope.daj(get_issues(this$0.bf4_1)).i1()) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        var tmp_1 = !$this$reactiveScope.daj(this$0.jf4_1).i1();
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_0 = !!(tmp_1 | !$this$reactiveScope.daj(this$0.kf4_1).i1());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    var tmp$ret$2 = tmp;
    this_0.set(tmp$ret$2);
    return Unit_instance;
  });
  dynamicTheme($this$button, ($this$dynamicTheme) => $this$dynamicTheme.daj(this$0.df4_1) ? DangerButtonSemantic_getInstance() : PrimaryButtonSemantic_getInstance());
  specCenteredText_0($this$button, ($this$specCenteredText) => $this$specCenteredText.daj(this$0.df4_1) ? 'Unpublish' : 'Submit Change');
  var tmp_1 = KMutableProperty0();
  var tmp_2 = Button$_get_action_$ref_cripsm($this$button);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('action', 0, tmp_1, tmp_2, Button$_set_action_$ref_rtraxu($this$button));
  reactiveScope($this$button, ($this$reactiveScope) => {
    var tmp;
    if ($this$reactiveScope.daj(this$0.df4_1)) {
      tmp = Action('Unpublish', VOID, ChangeOrderForm2$actionBar$publishButton$lambda$slambda_0(this$0, $this$button));
    } else {
      tmp = Action('Submit', VOID, ChangeOrderForm2$actionBar$publishButton$lambda$slambda_2($this$reactiveScope, this$0, $this$button));
    }
    var tmp$ret$4 = tmp;
    this_1.set(tmp$ret$4);
    return Unit_instance;
  });
  _this__u8e3s4.hbb(p, view);
  return view;
}
function subformControls$_anonymous_$expandingIfNarrow_f01g1r(_this__u8e3s4) {
  return get_viewIsNarrow(_this__u8e3s4) ? get_expanding(_this__u8e3s4) : Companion_getInstance_1();
}
function ChangeOrderForm2$changeOrderNumber$lambda(it) {
  return it.z57_1;
}
function ChangeOrderForm2$published$lambda(it) {
  return !(it.t57_1 == null);
}
var ChangeOrderForm2$linkItems$slambdaClass;
function ChangeOrderForm2$linkItems$slambda() {
  if (ChangeOrderForm2$linkItems$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ch5_1 = this$0;
      }
      ah7($this$interceptWrite, link, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, $this$interceptWrite, link), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, MutableValidated()) : false) ? p1 : THROW_CCE();
        return this.ah7(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ChangeOrderForm2$linkItems$slambdaClass = $;
  }
  return ChangeOrderForm2$linkItems$slambdaClass;
}
function ChangeOrderForm2$linkItems$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$linkItems$slambda())(this$0);
  var l = ($this$interceptWrite, link, $completion) => i.ah7($this$interceptWrite, link, $completion);
  l.$arity = 2;
  return l;
}
var ChangeOrderForm2$cardinalChange$slambdaClass;
function ChangeOrderForm2$cardinalChange$slambda() {
  if (ChangeOrderForm2$cardinalChange$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.dh5_1 = this$0;
      }
      ah7($this$interceptWrite, cardinal, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, $this$interceptWrite, cardinal), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, MutableValidated()) : false) ? p1 : THROW_CCE();
        return this.ah7(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ChangeOrderForm2$cardinalChange$slambdaClass = $;
  }
  return ChangeOrderForm2$cardinalChange$slambdaClass;
}
function ChangeOrderForm2$cardinalChange$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$cardinalChange$slambda())(this$0);
  var l = ($this$interceptWrite, cardinal, $completion) => i.ah7($this$interceptWrite, cardinal, $completion);
  l.$arity = 2;
  return l;
}
var ChangeOrderForm2$newItems$slambdaClass;
function ChangeOrderForm2$newItems$slambda() {
  if (ChangeOrderForm2$newItems$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.eh5_1 = this$0;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$newItems$slambdaClass = $;
  }
  return ChangeOrderForm2$newItems$slambdaClass;
}
function ChangeOrderForm2$newItems$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$newItems$slambda())(this$0);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
var ChangeOrderForm2$changedItems$slambdaClass;
function ChangeOrderForm2$changedItems$slambda() {
  if (ChangeOrderForm2$changedItems$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.gh5_1 = this$0;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$changedItems$slambdaClass = $;
  }
  return ChangeOrderForm2$changedItems$slambdaClass;
}
function ChangeOrderForm2$changedItems$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$changedItems$slambda())(this$0);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
var ChangeOrderForm2$save$slambdaClass;
function ChangeOrderForm2$save$slambda() {
  if (ChangeOrderForm2$save$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $includeItems) {
        this.lh5_1 = this$0;
        this.mh5_1 = $includeItems;
      }
      yah($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this, $this$coroutineScope), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$save$slambdaClass = $;
  }
  return ChangeOrderForm2$save$slambdaClass;
}
function ChangeOrderForm2$save$slambda_0(this$0, $includeItems) {
  var i = new (ChangeOrderForm2$save$slambda())(this$0, $includeItems);
  var l = ($this$coroutineScope, $completion) => i.yah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var ChangeOrderForm2$delete$slambdaClass;
function ChangeOrderForm2$delete$slambda() {
  if (ChangeOrderForm2$delete$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.oh5_1 = this$0;
      }
      yah($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this, $this$coroutineScope), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$delete$slambdaClass = $;
  }
  return ChangeOrderForm2$delete$slambdaClass;
}
function ChangeOrderForm2$delete$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$delete$slambda())(this$0);
  var l = ($this$coroutineScope, $completion) => i.yah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var ChangeOrderForm2$render$slambdaClass;
function ChangeOrderForm2$render$slambda() {
  if (ChangeOrderForm2$render$slambdaClass === VOID) {
    class $ {
      constructor($this_render, this$0) {
        this.ph5_1 = $this_render;
        this.qh5_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$render$slambdaClass = $;
  }
  return ChangeOrderForm2$render$slambdaClass;
}
function ChangeOrderForm2$render$slambda_0($this_render, this$0) {
  var i = new (ChangeOrderForm2$render$slambda())($this_render, this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function Checkbox$_get_enabled_$ref_57hbqa_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Checkbox.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Checkbox$_set_enabled_$ref_zhvi26_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Checkbox.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function ChangeOrderForm2$subformControls$lambda($this$specCenteredContent) {
  var tmp = get_compact($this$specCenteredContent);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$specCenteredContent.pc());
  var tmp0_elvis_lhs = $this$specCenteredContent.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$specCenteredContent : tmp0_elvis_lhs;
  $this$specCenteredContent.gbb(p, view);
  view.zbm(false);
  icon(view, Companion_getInstance_0().vcf_1, 'Remove Work Item');
  view.lbb(get_centered(view), body(view, get_viewIsNarrow(view) ? 'Remove' : 'Remove Work Item'));
  $this$specCenteredContent.hbb(p, view);
  return $this$specCenteredContent.lbb(tmp, view);
}
var ChangeOrderForm2$subformControls$slambdaClass;
function ChangeOrderForm2$subformControls$slambda() {
  if (ChangeOrderForm2$subformControls$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $removableOptions) {
        this.rh5_1 = this$0;
        this.sh5_1 = $removableOptions;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$subformControls$slambdaClass = $;
  }
  return ChangeOrderForm2$subformControls$slambdaClass;
}
function ChangeOrderForm2$subformControls$slambda_0(this$0, $removableOptions) {
  var i = new (ChangeOrderForm2$subformControls$slambda())(this$0, $removableOptions);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function ChangeOrderForm2$subformControls$lambda_0($this$specCenteredContent) {
  var tmp = get_compact($this$specCenteredContent);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$specCenteredContent.pc());
  var tmp0_elvis_lhs = $this$specCenteredContent.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$specCenteredContent : tmp0_elvis_lhs;
  $this$specCenteredContent.gbb(p, view);
  view.zbm(false);
  icon(view, get_edit(Companion_getInstance_0()).id5(get_rem(1.5), get_rem(1.5)), 'Modify Work Item');
  view.lbb(get_centered(view), body(view, get_viewIsNarrow(view) ? 'Modify' : 'Modify Work Item'));
  $this$specCenteredContent.hbb(p, view);
  return $this$specCenteredContent.lbb(tmp, view);
}
var ChangeOrderForm2$subformControls$slambdaClass_0;
function ChangeOrderForm2$subformControls$slambda_1() {
  if (ChangeOrderForm2$subformControls$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $availableOptions) {
        this.uh5_1 = this$0;
        this.vh5_1 = $availableOptions;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$subformControls$slambdaClass_0 = $;
  }
  return ChangeOrderForm2$subformControls$slambdaClass_0;
}
function ChangeOrderForm2$subformControls$slambda_2(this$0, $availableOptions) {
  var i = new (ChangeOrderForm2$subformControls$slambda_1())(this$0, $availableOptions);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function ChangeOrderForm2$subformControls$lambda_1($this$specCenteredContent) {
  var tmp = get_compact($this$specCenteredContent);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$specCenteredContent.pc());
  var tmp0_elvis_lhs = $this$specCenteredContent.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$specCenteredContent : tmp0_elvis_lhs;
  $this$specCenteredContent.gbb(p, view);
  view.zbm(false);
  icon(view, Companion_getInstance_0().ycf_1, 'New Work Item');
  view.lbb(get_centered(view), body(view, get_viewIsNarrow(view) ? 'New' : 'New Work Item'));
  $this$specCenteredContent.hbb(p, view);
  return $this$specCenteredContent.lbb(tmp, view);
}
var ChangeOrderForm2$subformControls$slambdaClass_1;
function ChangeOrderForm2$subformControls$slambda_3() {
  if (ChangeOrderForm2$subformControls$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.xh5_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_18.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$subformControls$slambdaClass_1 = $;
  }
  return ChangeOrderForm2$subformControls$slambdaClass_1;
}
function ChangeOrderForm2$subformControls$slambda_4(this$0) {
  var i = new (ChangeOrderForm2$subformControls$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ChangeOrderForm2$renderWide$slambdaClass;
function ChangeOrderForm2$renderWide$slambda() {
  if (ChangeOrderForm2$renderWide$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$col) {
        this.yh5_1 = this$0;
        this.zh5_1 = $$this$col;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_19.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$renderWide$slambdaClass = $;
  }
  return ChangeOrderForm2$renderWide$slambdaClass;
}
function ChangeOrderForm2$renderWide$slambda_0(this$0, $$this$col) {
  var i = new (ChangeOrderForm2$renderWide$slambda())(this$0, $$this$col);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_12(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_12(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_13(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_13(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_14(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_14(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_15(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_15(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_16(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_16(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_visible_$ref_cygc3o(p0) {
  return () => p0.ab9();
}
function TextView$_set_visible_$ref_rs9jjk(p0) {
  return (_this__u8e3s4) => {
    p0.zb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_visible_$ref_cygc3o_0(p0) {
  return () => p0.ab9();
}
function TextView$_set_visible_$ref_rs9jjk_0(p0) {
  return (_this__u8e3s4) => {
    p0.zb8(_this__u8e3s4);
    return Unit_instance;
  };
}
function IconView$_get_shown_$ref_js8irt(p0) {
  return () => p0.yb8();
}
function IconView$_set_shown_$ref_9ilxmr(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_17(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_17(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ChangeOrderForm2$renderWide$lambda($this$share, items) {
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var sum = Companion_instance.r91(0n);
  var _iterator__ex2g4s = items.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp = sum;
    var tmp$ret$0 = $this$share.daj(element.mh4_1).y75_1;
    sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$0);
  }
  var tmp$ret$1 = sum;
  return new (MonetaryValue())(tmp$ret$1);
}
function TextView$_get_content_$ref_4pzcwl_18(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_18(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ChangeOrderForm2$renderWide$lambda_0($this$forEach, it) {
  // Inline function 'kotlin.with' call
  it.xh6($this$forEach);
  return Unit_instance;
}
var ChangeOrderForm2$renderWide$slambdaClass_0;
function ChangeOrderForm2$renderWide$slambda_1() {
  if (ChangeOrderForm2$renderWide$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.ah6_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_20.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$renderWide$slambdaClass_0 = $;
  }
  return ChangeOrderForm2$renderWide$slambdaClass_0;
}
function ChangeOrderForm2$renderWide$slambda_2(this$0) {
  var i = new (ChangeOrderForm2$renderWide$slambda_1())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_19(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_19(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function ChangeOrderForm2$itemsSection$lambda($this$forEach, it) {
  // Inline function 'kotlin.run' call
  it.yh6($this$forEach);
  return Unit_instance;
}
function ChangeOrderForm2$createModification$lambda(it) {
  return it === 0 ? 'Select Items' : 'Modify (' + it + ') Items';
}
var ChangeOrderForm2$createModification$slambdaClass;
function ChangeOrderForm2$createModification$slambda() {
  if (ChangeOrderForm2$createModification$slambdaClass === VOID) {
    class $ {
      constructor($changeOrder, $orderNumber, $subOrderNumber) {
        this.bh6_1 = $changeOrder;
        this.ch6_1 = $orderNumber;
        this.dh6_1 = $subOrderNumber;
      }
      bh7(selected, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_21.bind(VOID, this, selected), $completion);
      }
      s2(p1, $completion) {
        return this.bh7((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$createModification$slambdaClass = $;
  }
  return ChangeOrderForm2$createModification$slambdaClass;
}
function ChangeOrderForm2$createModification$slambda_0($changeOrder, $orderNumber, $subOrderNumber) {
  var i = new (ChangeOrderForm2$createModification$slambda())($changeOrder, $orderNumber, $subOrderNumber);
  var l = (selected, $completion) => i.bh7(selected, $completion);
  l.$arity = 1;
  return l;
}
function ChangeOrderForm2$createRemoval$lambda(it) {
  return it === 0 ? 'Select Items' : 'Remove (' + it + ') Items';
}
var ChangeOrderForm2$createRemoval$slambdaClass;
function ChangeOrderForm2$createRemoval$slambda() {
  if (ChangeOrderForm2$createRemoval$slambdaClass === VOID) {
    class $ {
      constructor($changeOrder, $orderNumber, $subOrderNumber) {
        this.eh6_1 = $changeOrder;
        this.fh6_1 = $orderNumber;
        this.gh6_1 = $subOrderNumber;
      }
      bh7(selected, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_22.bind(VOID, this, selected), $completion);
      }
      s2(p1, $completion) {
        return this.bh7((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$createRemoval$slambdaClass = $;
  }
  return ChangeOrderForm2$createRemoval$slambdaClass;
}
function ChangeOrderForm2$createRemoval$slambda_0($changeOrder, $orderNumber, $subOrderNumber) {
  var i = new (ChangeOrderForm2$createRemoval$slambda())($changeOrder, $orderNumber, $subOrderNumber);
  var l = (selected, $completion) => i.bh7(selected, $completion);
  l.$arity = 1;
  return l;
}
var ChangeOrderForm2$actionBar$saveButton$slambdaClass;
function ChangeOrderForm2$actionBar$saveButton$slambda() {
  if (ChangeOrderForm2$actionBar$saveButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.hh6_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_23.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$actionBar$saveButton$slambdaClass = $;
  }
  return ChangeOrderForm2$actionBar$saveButton$slambdaClass;
}
function ChangeOrderForm2$actionBar$saveButton$slambda_0(this$0) {
  var i = new (ChangeOrderForm2$actionBar$saveButton$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ChangeOrderForm2$actionBar$saveAndCloseButton$slambdaClass;
function ChangeOrderForm2$actionBar$saveAndCloseButton$slambda() {
  if (ChangeOrderForm2$actionBar$saveAndCloseButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.jh6_1 = this$0;
        this.kh6_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_24.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$actionBar$saveAndCloseButton$slambdaClass = $;
  }
  return ChangeOrderForm2$actionBar$saveAndCloseButton$slambdaClass;
}
function ChangeOrderForm2$actionBar$saveAndCloseButton$slambda_0(this$0, $$this$button) {
  var i = new (ChangeOrderForm2$actionBar$saveAndCloseButton$slambda())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ChangeOrderForm2$actionBar$discardButton$slambdaClass;
function ChangeOrderForm2$actionBar$discardButton$slambda() {
  if (ChangeOrderForm2$actionBar$discardButton$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.ch7_1 = $$this$button;
        this.dh7_1 = this$0;
      }
      uao($completion) {
        confirmationDialog(this.ch7_1, 'Discard Changes?', 'You have changes that have not been submitted. Discarded changes cannot be recovered. Discard changes and leave?', 'Discard & Leave', VOID, VOID, VOID, VOID, VOID, VOID, ChangeOrderForm2$actionBar$discardButton$slambda$slambda_0(this.ch7_1, this.dh7_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$actionBar$discardButton$slambdaClass = $;
  }
  return ChangeOrderForm2$actionBar$discardButton$slambdaClass;
}
function ChangeOrderForm2$actionBar$discardButton$slambda_0($$this$button, this$0) {
  var i = new (ChangeOrderForm2$actionBar$discardButton$slambda())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ChangeOrderForm2$actionBar$deleteButton$slambdaClass;
function ChangeOrderForm2$actionBar$deleteButton$slambda() {
  if (ChangeOrderForm2$actionBar$deleteButton$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.eh7_1 = $$this$button;
        this.fh7_1 = this$0;
      }
      uao($completion) {
        var tmp = DangerButtonSemantic_getInstance();
        confirmationDialog(this.eh7_1, 'Delete Draft?', 'You are about to delete this change order draft. Deleted drafts cannot be recovered. Delete this draft?', 'Delete Draft', VOID, tmp, VOID, VOID, VOID, VOID, ChangeOrderForm2$actionBar$deleteButton$slambda$slambda_0(this.eh7_1, this.fh7_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ChangeOrderForm2$actionBar$deleteButton$slambdaClass = $;
  }
  return ChangeOrderForm2$actionBar$deleteButton$slambdaClass;
}
function ChangeOrderForm2$actionBar$deleteButton$slambda_0($$this$button, this$0) {
  var i = new (ChangeOrderForm2$actionBar$deleteButton$slambda())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
function Button$_get_action_$ref_cripsm(p0) {
  return () => p0.mbg_1;
}
function Button$_set_action_$ref_rtraxu(p0) {
  return (_this__u8e3s4) => {
    p0.obg(_this__u8e3s4);
    return Unit_instance;
  };
}
var ChangeOrderForm2$actionBar$publishButton$lambda$slambdaClass;
function ChangeOrderForm2$actionBar$publishButton$lambda$slambda() {
  if (ChangeOrderForm2$actionBar$publishButton$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.gh7_1 = this$0;
        this.hh7_1 = $$this$button;
      }
      yah($this$Action, $completion) {
        var tmp = get_dialogStack();
        var tmp_0 = DangerButtonSemantic_getInstance();
        tmp.zgd(new (GenericConfirmationDialog())('Unpublish Change Request?', 'Unpublishing will make it unavailable for approval or denial. ', VOID, 'Unpublish Change Request', VOID, tmp_0, VOID, VOID, VOID, VOID, ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambda_0(this.gh7_1, this.hh7_1)));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$actionBar$publishButton$lambda$slambdaClass = $;
  }
  return ChangeOrderForm2$actionBar$publishButton$lambda$slambdaClass;
}
function ChangeOrderForm2$actionBar$publishButton$lambda$slambda_0(this$0, $$this$button) {
  var i = new (ChangeOrderForm2$actionBar$publishButton$lambda$slambda())(this$0, $$this$button);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var ChangeOrderForm2$actionBar$publishButton$lambda$slambdaClass_0;
function ChangeOrderForm2$actionBar$publishButton$lambda$slambda_1() {
  if (ChangeOrderForm2$actionBar$publishButton$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$invoke, this$0, $$this$button) {
        this.ih7_1 = $$this$invoke;
        this.jh7_1 = this$0;
        this.kh7_1 = $$this$button;
      }
      yah($this$Action, $completion) {
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = this.ih7_1.iaj(this.jh7_1.kf4_1);
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (this.ih7_1.iaj(element.yh3_1)) {
            destination.v(element);
          }
        }
        var blankItems = destination;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!blankItems.i1()) {
          this.jh7_1.if4_1.oam(true);
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_0 = blankItems.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            set_value(element_0.xh3_1, true);
          }
          var tmp = get_dialogStack();
          tmp.zgd(GenericDialog().bgz('Every changed work item needs a price change or an updated description. Fill in or delete:' + joinToString(blankItems, '\n -', '\n -', VOID, VOID, VOID, (it) => this.ih7_1.iaj(it.zh3_1))));
          return Unit_instance;
        }
        // Inline function 'kotlin.takeIf' call
        var this_0 = this.ih7_1.daj(this.jh7_1.af4_1.rat_1);
        var tmp_0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_0.i1()) {
          tmp_0 = this_0;
        } else {
          tmp_0 = null;
        }
        var tmp0_safe_receiver = tmp_0;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          get_dialogStack().zgd(GenericDialog().bgz('One or more required items is missing or invalid: ' + joinToString(tmp0_safe_receiver, '\n -', '\n -')));
          return Unit_instance;
        }
        var tmp_1 = get_dialogStack();
        var tmp_2 = PrimaryButtonSemantic_getInstance();
        tmp_1.zgd(new (GenericConfirmationDialog())('Submit Change Request?', 'Submitting this change request will make it available to view and be accepted by the client. Please make sure all project details are correct before proceeding. Once the client accepts or denys any item, no changes can be made.', VOID, 'Submit Change Request', VOID, tmp_2, VOID, VOID, VOID, VOID, ChangeOrderForm2$actionBar$publishButton$lambda$slambda$slambda_2(this.jh7_1, this.kh7_1)));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ChangeOrderForm2$actionBar$publishButton$lambda$slambdaClass_0 = $;
  }
  return ChangeOrderForm2$actionBar$publishButton$lambda$slambdaClass_0;
}
function ChangeOrderForm2$actionBar$publishButton$lambda$slambda_2($$this$invoke, this$0, $$this$button) {
  var i = new (ChangeOrderForm2$actionBar$publishButton$lambda$slambda_1())($$this$invoke, this$0, $$this$button);
  var l = ($this$Action, $completion) => i.yah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function FormSection_Settings_getInstance() {
  FormSection_initEntries();
  return FormSection_Settings_instance;
}
function FormSection_Changes_getInstance() {
  FormSection_initEntries();
  return FormSection_Changes_instance;
}
var ChangeOrderForm2Class;
function ChangeOrderForm2() {
  if (ChangeOrderForm2Class === VOID) {
    class $ {
      constructor(projectId, changeOrderId, parent) {
        parent = parent === VOID ? null : parent;
        var tmp = this;
        tmp.xf3_1 = parent == null ? new (Data())(ProjectLens_Contractor_getInstance(), projectId) : parent;
        this.yf3_1 = projectId;
        this.zf3_1 = changeOrderId;
        this.af4_1 = new (IssueNode())(null);
        var tmp_0 = this;
        tmp_0.bf4_1 = validated(Draft_0(($this$Draft) => {
          var tmp0_elvis_lhs = $this$Draft.daj($this$Draft.daj(get_session()).jfv_1.mft(this.zf3_1));
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw NotFound().pfx(getKClass(ChangeRequest()), null);
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        }), this.af4_1);
        var tmp_1 = this;
        var tmp_2 = this.bf4_1.aak();
        tmp_1.cf4_1 = lens(tmp_2, ChangeOrderForm2$changeOrderNumber$lambda);
        var tmp_3 = this;
        var tmp_4 = this.bf4_1.aak();
        tmp_3.df4_1 = lens(tmp_4, ChangeOrderForm2$published$lambda);
        var tmp_5 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_0 = this.bf4_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_6 = serializerOrContextual(createKType(getKClass(ChangeRequest()), arrayOf([]), false));
        var tmp$ret$0 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$0);
        var tmp$ret$2 = get_scopeSet(it);
        tmp_5.ef4_1 = lensPath(this_0, tmp$ret$2);
        var tmp_7 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_1 = this.bf4_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_8 = serializerOrContextual(createKType(getKClass(ChangeRequest()), arrayOf([]), false));
        var tmp$ret$4 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$4);
        var tmp$ret$6 = get_linkItems(it_0);
        var tmp_9 = lensPath(this_1, tmp$ret$6);
        tmp_7.ff4_1 = interceptWrite(tmp_9, ChangeOrderForm2$linkItems$slambda_0(this));
        var tmp_10 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_2 = this.bf4_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_11 = serializerOrContextual(createKType(getKClass(ChangeRequest()), arrayOf([]), false));
        var tmp$ret$8 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
        var it_1 = new (DataClassPathSelf())(tmp$ret$8);
        var tmp$ret$10 = get_cardinalChange(it_1);
        var tmp_12 = lensPath(this_2, tmp$ret$10);
        tmp_10.gf4_1 = interceptWrite(tmp_12, ChangeOrderForm2$cardinalChange$slambda_0(this));
        this.hf4_1 = false;
        this.if4_1 = Signal().hak(false);
        var tmp_13 = this;
        tmp_13.jf4_1 = rememberSuspending(VOID, VOID, VOID, ChangeOrderForm2$newItems$slambda_0(this));
        var tmp_14 = this;
        tmp_14.kf4_1 = rememberSuspending(VOID, VOID, VOID, ChangeOrderForm2$changedItems$slambda_0(this));
        var tmp_15 = this;
        tmp_15.lf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.sortedBy' call
          var this_0 = plus($this$remember.daj(this.jf4_1), $this$remember.daj(this.kf4_1));
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp = (a, b) => {
            // Inline function 'kotlin.comparisons.compareValuesBy' call
            var tmp = $this$remember.daj(a.y94());
            var tmp$ret$13 = $this$remember.daj(b.y94());
            return compareValues(tmp, tmp$ret$13);
          };
          var tmp$ret$15 = new (sam$kotlin_Comparator$0())(tmp);
          return sortedWith(this_0, tmp$ret$15);
        });
        var tmp_16 = this;
        tmp_16.mf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var this_0 = $this$remember.daj(this.lf4_1);
          var sum = Companion_instance.r91(0n);
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp = sum;
            var tmp$ret$17 = $this$remember.daj(element.wh6()).y5r_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$17);
          }
          var tmp$ret$18 = sum;
          return new (MonetaryValue())(tmp$ret$18);
        });
        var tmp_17 = this;
        tmp_17.nf4_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var items = $this$remember.daj(this.jf4_1);
          var tmp = $this$remember.daj(this.ff4_1);
          var tmp$ret$19;
          $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var tmp_0;
            if (isInterface(items, Collection())) {
              tmp_0 = items.i1();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$19 = true;
              break $l$block_0;
            }
            var _iterator__ex2g4s = items.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (!$this$remember.daj(element.mh4_1).a76_1) {
                tmp$ret$19 = false;
                break $l$block_0;
              }
            }
            tmp$ret$19 = true;
          }
          var tmp_1 = !!(tmp & tmp$ret$19);
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !!(tmp_1 & !items.i1());
        });
        var tmp_18 = this;
        tmp_18.of4_1 = MutableRemember().tak(VOID, VOID, VOID, VOID, ($this$MutableRemember) => {
          var tmp;
          // Inline function 'kotlin.let' call
          var it = $this$MutableRemember.gaj(this.bf4_1);
          if (isBlank(it.q57_1) || isBlank(it.r57_1)) {
            tmp = FormSection_Settings_getInstance();
          } else {
            tmp = FormSection_Changes_getInstance();
          }
          return tmp;
        });
        this.pf4_1 = HashMap().n8();
        this.qf4_1 = HashMap().n8();
      }
      lf8() {
        return this.yf3_1;
      }
      hh4(form, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_notifyDeleting__mfax07.bind(VOID, this, form), $completion);
      }
      lh7(includeItems, $completion) {
        return coroutineScope(ChangeOrderForm2$save$slambda_0(this, includeItems), $completion);
      }
      ih6(includeItems, $completion, $super) {
        includeItems = includeItems === VOID ? true : includeItems;
        return $super === VOID ? this.lh7(includeItems, $completion) : $super.lh7.call(this, includeItems, $completion);
      }
      kem($completion) {
        return coroutineScope(ChangeOrderForm2$delete$slambda_0(this), $completion);
      }
      bak($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_publish__pkz857.bind(VOID, this), $completion);
      }
      sh6($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_unpublish__6khfdq.bind(VOID, this), $completion);
      }
      vh6(_this__u8e3s4) {
        if (get_viewIsNarrow(_this__u8e3s4)) {
          var tmp = get_darkSection(_this__u8e3s4);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())(_this__u8e3s4.pc());
          var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
          var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
          _this__u8e3s4.gbb(p, view);
          view.zbm(false);
          view.bb9(get_AppDimensions().kg2_1);
          view.gba(get_AppDimensions().kg2_1);
          actionBar$deleteButton(view, this);
          var tmp_0 = get_expanding(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Space())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view.hbb(p_0, view_0);
          view.lbb(tmp_0, view_0);
          actionBar$saveButton(view, this);
          actionBar$publishButton(view, this);
          _this__u8e3s4.hbb(p, view);
          _this__u8e3s4.lbb(tmp, view);
        } else {
          var tmp_1 = get_darkSection(_this__u8e3s4);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(_this__u8e3s4.pc());
          var tmp0_elvis_lhs_1 = _this__u8e3s4.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? _this__u8e3s4 : tmp0_elvis_lhs_1;
          _this__u8e3s4.gbb(p_1, view_1);
          view_1.zbm(false);
          view_1.bb9(get_AppDimensions().kg2_1);
          view_1.gba(get_AppDimensions().kg2_1);
          actionBar$saveButton(view_1, this);
          actionBar$saveAndCloseButton(view_1, this);
          actionBar$discardButton(view_1, this);
          actionBar$deleteButton(view_1, this);
          var tmp_2 = get_expanding(view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.space' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Space())(view_1.pc());
          var tmp0_elvis_lhs_2 = view_1.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
          view_1.gbb(p_2, view_2);
          view_1.hbb(p_2, view_2);
          view_1.lbb(tmp_2, view_2);
          actionBar$publishButton(view_1, this);
          _this__u8e3s4.hbb(p_1, view_1);
          _this__u8e3s4.lbb(tmp_1, view_1);
        }
      }
      wd6(_this__u8e3s4) {
        var view = get_viewIsNarrow(_this__u8e3s4) ? renderNarrow(this, _this__u8e3s4) : renderWide(this, _this__u8e3s4);
        // Inline function 'kotlin.also' call
        launch(_this__u8e3s4, VOID, VOID, ChangeOrderForm2$render$slambda_0(_this__u8e3s4, this));
        return view;
      }
      hh5(itemChange, jumpOnNew, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_itemChangeForm__413zbz.bind(VOID, this, itemChange, jumpOnNew), $completion);
      }
      fh5(lineItem, jumpOnNew, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_newItemForm__zi8f8j.bind(VOID, this, lineItem, jumpOnNew), $completion);
      }
      wh5(changeOrder, orderNumber, subOrderNumber, choices) {
        var tmp = ChangeOrderForm2$createModification$lambda;
        return new (MultiselectFromItemsDialog())(choices, 'Modify Work Item(s)', tmp, VOID, ChangeOrderForm2$createModification$slambda_0(changeOrder, orderNumber, subOrderNumber));
      }
      th5(changeOrder, orderNumber, subOrderNumber, choices) {
        var tmp = ChangeOrderForm2$createRemoval$lambda;
        return new (MultiselectFromItemsDialog())(choices, 'Remove Line Item(s)', tmp, VOID, ChangeOrderForm2$createRemoval$slambda_0(changeOrder, orderNumber, subOrderNumber));
      }
      lfy() {
        return this.xf3_1.lfy();
      }
      vgm() {
        return this.xf3_1.vgm();
      }
      zgz() {
        return this.xf3_1.zgz();
      }
      ygk() {
        return this.xf3_1.ygk();
      }
      hgl() {
        return this.xf3_1.hgl();
      }
      wgm() {
        return this.xf3_1.wgm();
      }
      xgv() {
        return this.xf3_1.xgv();
      }
      ngy() {
        return this.xf3_1.ngy();
      }
      kgt() {
        return this.xf3_1.kgt();
      }
      lgt() {
        return this.xf3_1.lgt();
      }
      jgt() {
        return this.xf3_1.jgt();
      }
      dgt() {
        return this.xf3_1.dgt();
      }
      ggt() {
        return this.xf3_1.ggt();
      }
      pgf() {
        return this.xf3_1.pgf();
      }
      qh2() {
        return this.xf3_1.qh2();
      }
      ogf() {
        return this.xf3_1.ogf();
      }
      uh2() {
        return this.xf3_1.uh2();
      }
    }
    protoOf($).wcv = get_title_0;
    initMetadataForClass($, 'ChangeOrderForm2', VOID, VOID, [Page()], [1, 0, 2]);
    ChangeOrderForm2Class = $;
  }
  return ChangeOrderForm2Class;
}
//region block: exports
export {
  ChangeOrderForm2 as ChangeOrderForm23hgjlgmtvjevd,
};
//endregion

//# sourceMappingURL=ChangeOrderForm2.mjs.map
